unit View.Fs_Prod_Produtos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, UUtils,
  WEBLib.JSON, WEBLib.WebCtrls, WEBLib.Grids, WEBLib.Lists, Grid.Plugins,
  UConstantes, System.StrUtils, UWeb.Enum, Web;

type
  TFViewFs_Prod_ProdutosEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo_barras: TLabel;
    edcodigo_barras: TDBEdit;
    lbcategoria_id: TLabel;
    lbsubcategoria_id: TLabel;
    lbdepartamento_id: TLabel;
    lbsubdepartamento_id: TLabel;
    lbmarca_id: TLabel;
    lbfabricante_id: TLabel;
    lbcodigos: TLabel;
    edcodigos: TDBEdit;
    lbpeso: TLabel;
    edpeso: TDBEdit;
    lbembalagem: TLabel;
    edembalagem: TDBEdit;
    lbquantidade_embalagem: TLabel;
    edquantidade_embalagem: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientFs_Prod_ProdutosGet: TXDataWebClient;
    Fs_Prod_ProdutosDataset: TXDataWebDataSet;
    Fs_Prod_ProdutosDatasetid: TIntegerField;
    Fs_Prod_ProdutosDatasetnome: TStringField;
    Fs_Prod_ProdutosDatasetcodigo_barras: TStringField;
    Fs_Prod_ProdutosDatasetcategoria_id: TIntegerField;
    Fs_Prod_ProdutosDatasetsubcategoria_id: TIntegerField;
    Fs_Prod_ProdutosDatasetdepartamento_id: TIntegerField;
    Fs_Prod_ProdutosDatasetsubdepartamento_id: TIntegerField;
    Fs_Prod_ProdutosDatasetmarca_id: TIntegerField;
    Fs_Prod_ProdutosDatasetfabricante_id: TIntegerField;
    Fs_Prod_ProdutosDatasetcodigos: TStringField;
    Fs_Prod_ProdutosDatasetpeso: TStringField;
    Fs_Prod_ProdutosDatasetembalagem: TStringField;
    Fs_Prod_ProdutosDatasetquantidade_embalagem: TStringField;
    Fs_Prod_ProdutosDatasetfoto: TStringField;
    Fs_Prod_ProdutosDatasetexcluido: TBooleanField;
    Fs_Prod_ProdutosDatasetinclusao: TDateTimeField;
    Fs_Prod_ProdutosDatasetalteracao: TDateTimeField;
    Fs_Prod_ProdutosDatasetexclusao: TDateTimeField;
    Fs_Prod_ProdutosDatasetimagem: TStringField;
    edtCategoriaNome: TEdit;
    btnPesquisarCategoria: TButton;
    edtSubCategoriaNome: TEdit;
    btnPesquisarSubCategoria: TButton;
    edtDepartamentoNome: TEdit;
    btnPesquisarDepartamento: TButton;
    edtSubDepartamentoNome: TEdit;
    btnPesquisarSubDepartamento: TButton;
    edtMarcaNome: TEdit;
    btnPesquisarMarca: TButton;
    edtFabricanteNome: TEdit;
    btnPesquisarFabricante: TButton;
    cbExcluido: TDBCheckBox;
    Fs_Prod_ProdutosDatasetcategorianome: TStringField;
    Fs_Prod_ProdutosDatasetsubcategorianome: TStringField;
    Fs_Prod_ProdutosDatasetdepartamentonome: TStringField;
    Fs_Prod_ProdutosDatasetsubdepartamentonome: TStringField;
    Fs_Prod_ProdutosDatasetmarcanome: TStringField;
    Fs_Prod_ProdutosDatasetfabricantenome: TStringField;
    btnDadosTab: TButton;
    btnAdicionaisTab: TButton;
    imgProduto: TImageControl;
    lbncm: TLabel;
    edncm: TDBEdit;
    lbcest: TLabel;
    edcest: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lbdescricao_sem_tag: TLabel;
    eddescricao_sem_tag: TDBEdit;
    lbinfo_nutricional_json: TLabel;
    edinfo_nutricional_json: TDBEdit;
    lbficha_tecnica: TLabel;
    edficha_tecnica: TDBEdit;
    cdsTributacoes: TXDataWebDataSet;
    Fs_Prod_ProdutosDatasettributacao: TXDataWebEntityField;
    dtsTributacoes: TDataSource;
    cdsInformacoesAdicionais: TXDataWebDataSet;
    cdsInformacoesAdicionaisid: TIntegerField;
    cdsInformacoesAdicionaisproduto_id: TIntegerField;
    cdsInformacoesAdicionaisdescricao: TStringField;
    cdsInformacoesAdicionaisdescricao_sem_tag: TStringField;
    cdsInformacoesAdicionaisinfo_nutricional_json: TStringField;
    cdsInformacoesAdicionaisficha_tecnica: TStringField;
    cdsInformacoesAdicionaisexcluido: TBooleanField;
    cdsInformacoesAdicionaisinclusao: TDateTimeField;
    cdsInformacoesAdicionaisalteracao: TDateTimeField;
    cdsInformacoesAdicionaisexclusao: TDateTimeField;
    dtsInformacoesAdicionais: TDataSource;
    Fs_Prod_ProdutosDatasetadicional: TXDataWebEntityField;
    XDataWebClientGerenciarProdutos: TXDataWebClient;
    lbPaginationInfoCaracteristicas: TLabel;
    pnlTabelaCaracteristicas: TPanel;
    cbPageSizeCaracteristicas: TComboBox;
    edSearchCaracteristicas: TEdit;
    lcPaginatorCaracteristicas: TListControl;
    tblCaracteristicas: TDBTableControl;
    cdsCaracteristicas: TXDataWebDataSet;
    dtsCaracteristicas: TDataSource;
    cdsCaracteristicasid: TIntegerField;
    cdsCaracteristicasvalor: TStringField;
    cdsCaracteristicasproduto_id: TIntegerField;
    cdsCaracteristicascaracteristicatipo: TStringField;
    btnCaracteristicasTab: TButton;
    tmrConsultaCaracteristicas: TTimer;
    lblCaracteristica: TLabel;
    edtCaracteristica: TEdit;
    btnPesquisarCaracteristica: TButton;
    btnNovaCaracteristica: TButton;
    btnSalvarCaracteristica: TButton;
    lblValor: TLabel;
    edtValor: TEdit;
    cdsCaracteristicascaracteristica_id: TIntegerField;
    btnAlterarImagem: TButton;
    XDataWebSugestaoImagem: TXDataWebClient;
    btnPesquisarImagem: TButton;
    edtNomeProduto: TEdit;
    edtCodigoProduto: TEdit;
    btnSalvarImagem: TButton;
    btnRemoverImagemPreview: TButton;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientFs_Prod_ProdutosGetLoad(Response: TXDataClientResponse);
    procedure btnPesquisarCategoriaClick(Sender: TObject);
    procedure btnPesquisarSubCategoriaClick(Sender: TObject);
    procedure btnPesquisarDepartamentoClick(Sender: TObject);
    procedure btnPesquisarSubDepartamentoClick(Sender: TObject);
    procedure btnPesquisarMarcaClick(Sender: TObject);
    procedure btnPesquisarFabricanteClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure ednomeClick(Sender: TObject);
    procedure edcodigo_barrasClick(Sender: TObject);
    procedure cbExcluidoClick(Sender: TObject);
    procedure edcodigo_barrasKeyPress(Sender: TObject; var Key: Char);
    procedure XDataWebClientGerenciarProdutosError(Error: TXDataClientError);
    procedure XDataWebClientGerenciarProdutosLoad(
      Response: TXDataClientResponse);
    procedure btnCaracteristicasTabClick(Sender: TObject);
    procedure tmrConsultaCaracteristicasTimer(Sender: TObject);
    procedure edSearchCaracteristicasKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchCaracteristicasKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure cbPageSizeCaracteristicasChange(Sender: TObject);
    procedure tblCaracteristicasGetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblCaracteristicasGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure cdsCaracteristicasAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure btnPesquisarCaracteristicaClick(Sender: TObject);
    procedure btnNovaCaracteristicaClick(Sender: TObject);
    [async]
    procedure btnSalvarCaracteristicaClick(Sender: TObject); async;
    procedure edtValorClick(Sender: TObject);
    procedure btnAlterarImagemClick(Sender: TObject);
    procedure btnRemoverImagemPreviewClick(Sender: TObject);
    procedure XDataWebSugestaoImagemError(Error: TXDataClientError);
    procedure XDataWebSugestaoImagemLoad(Response: TXDataClientResponse);
    procedure btnPesquisarImagemClick(Sender: TObject);
    procedure btnSalvarImagemClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginCaracteristicas : TGridPlugin;
    FImagemSelecionada : string;

    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    procedure SetDadosVisualizacao;
    function GetJsonUpdate : TJSObject;
    function GetJsonInsert : TJSObject;
    procedure SetDadosAlterados;
    procedure SetValueOrNullInteger(pCampo: string; pValor: Integer; var pCds: TXDataWebDataSet);
    procedure RemoverImagem;
    procedure CarregarImagemProduto;
    procedure ReiniciarCaracteristica;
    procedure OcultarMostrarBotaoRemoverImagem;
    function GetImagemPreview : TJSHTMLElement;
    procedure ExibirMensagemInformacao(const pMensagem: string);
    procedure LimparSelecaoSeletorImagens;
    function VerificarAtualizacaoImagem : Boolean;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewFs_Prod_ProdutosEdit: TFViewFs_Prod_ProdutosEdit;

implementation

uses
  ConnectionModule,
  View.Main;

{$R *.dfm}

{ TFViewFs_Prod_ProdutosEdit }

procedure TFViewFs_Prod_ProdutosEdit.btnAlterarImagemClick(Sender: TObject);
var
  lSeletorImagens: TJSHTMLElement;
begin
  TJSHTMLImageElement(GetImagemPreview).src := imgProduto.URL;

  edtCodigoProduto.Text := edid.Text;
  edtNomeProduto.Text := ednome.Text;

  lSeletorImagens := TJSHTMLElement(Document.getElementById('seletorImagens'));

  if Assigned(lSeletorImagens) then
    lSeletorImagens.innerHTML := EmptyStr;

  OcultarMostrarBotaoRemoverImagem;

  TUtils.OpenModal('modal_buscar_imagem');
end;

procedure TFViewFs_Prod_ProdutosEdit.btnCaracteristicasTabClick(
  Sender: TObject);
begin
  edSearchCaracteristicas.Text := EmptyStr;
  cbPageSizeCaracteristicas.ItemIndex := 0;

  if not Assigned(FGridPluginCaracteristicas) then
  begin
    FGridPluginCaracteristicas := TGridPlugin.Create(tblCaracteristicas, cdsCaracteristicas,
      lcPaginatorCaracteristicas, lbPaginationInfoCaracteristicas);

    FGridPluginCaracteristicas.FDatasetPlugin.FOrderByPadrao := 'id desc';
    FGridPluginCaracteristicas.FDatasetPlugin.FFilterPadrao := 'produto_id eq ' + edid.Text;
    FGridPluginCaracteristicas.SetPageSize(StrToInt(cbPageSizeCaracteristicas.Text));
    FGridPluginCaracteristicas.SetFilterText(edSearchCaracteristicas.Text);
  end;

  FGridPluginCaracteristicas.Load;
end;

procedure TFViewFs_Prod_ProdutosEdit.btnNovaCaracteristicaClick(
  Sender: TObject);
begin
  ReiniciarCaracteristica;
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarCaracteristicaClick(
  Sender: TObject);
begin
  TUtils.RemoverErroClass('lbcaracteristica');
  THelperServer.ChamarConsulta('Características', 'Fs_Prod_Caracteristicas', edtCaracteristica, True);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarCategoriaClick(
  Sender: TObject);
begin
  THelperServer.ChamarConsulta('Categorias', 'Fs_Prod_Categorias', edtCategoriaNome, True);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarDepartamentoClick(
  Sender: TObject);
begin
  THelperServer.ChamarConsulta('Departamentos', 'Fs_Prod_Departamentos', edtDepartamentoNome, True);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarFabricanteClick(
  Sender: TObject);
begin
  THelperServer.ChamarConsulta('Fabricantes', 'Fs_Prod_Fabricantes', edtFabricanteNome, True);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarImagemClick(Sender: TObject);
var
  lJson: TJSObject;
  lArray: TJSArray;
begin
  if Trim(edtNomeProduto.Text).IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Insira o nome do produto para pesquisar!');
    Exit;
  end;

  TUtils.ChamarDivLoading;
  lArray := TJSArray.new;
  lJson := TJSObject.New;
  lJson['nome'] := edtNomeProduto.Text;
  lJson['codigo'] := edtCodigoProduto.Text;
  lJson['size'] := 5;
  lArray.push(lJson);

  FImagemSelecionada := EmptyStr;

  XDataWebSugestaoImagem.RawInvoke('IService.GetSugestaoImagemProdutos', [lArray]);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarMarcaClick(Sender: TObject);
begin
  THelperServer.ChamarConsulta('Marcas', 'Fs_Prod_Marcas', edtMarcaNome, True);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarSubCategoriaClick(
  Sender: TObject);
begin
  THelperServer.ChamarConsulta('SubCategorias', 'Fs_Prod_SubCategorias', edtSubCategoriaNome, True);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnPesquisarSubDepartamentoClick(
  Sender: TObject);
begin
  THelperServer.ChamarConsulta('SubDepartamentos', 'Fs_Prod_SubDepartamentos', edtSubDepartamentoNome, True);
end;

procedure TFViewFs_Prod_ProdutosEdit.btnRemoverImagemPreviewClick(
  Sender: TObject);
begin
  RemoverImagem;
  OcultarMostrarBotaoRemoverImagem;
end;

procedure TFViewFs_Prod_ProdutosEdit.btnSalvarCaracteristicaClick(
  Sender: TObject);
begin
  if edtCaracteristica.Tag = 0 then
  begin
    TUtils.SetErroClass('lbcaracteristica', 'Insira a característica!');
    Exit;
  end;

  if Trim(edtValor.Text).IsEmpty then
  begin
    TUtils.SetErroClass('lbvalor', 'Preencha o valor!');
    Exit;
  end;


  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja adicionar a característica?')) then
  begin
    TUtils.ChamarDivLoading;
    cdsCaracteristicas.Append;
    cdsCaracteristicas.FieldByName('caracteristica_id').AsInteger := edtCaracteristica.Tag;
    cdsCaracteristicas.FieldByName('produto_id').AsInteger := StrToInt(edid.Text);
    cdsCaracteristicas.FieldByName('valor').AsString := edtValor.Text;
    cdsCaracteristicas.Post;
    cdsCaracteristicas.ApplyUpdates;
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.btnSalvarImagemClick(Sender: TObject);
begin
  imgProduto.URL := TJSHTMLImageElement(GetImagemPreview).src;

  TUtils.CloseModal('modal_buscar_imagem');
end;

procedure TFViewFs_Prod_ProdutosEdit.btSaveClick(Sender: TObject);
var
  lJson : TJSObject;
begin
  if THelperServer.VerificarCampoVazio(ednome) then
  begin
    TUtils.SetErroClass('lbnome', 'Preencha o nome!');
    Exit;
  end;
  if THelperServer.VerificarCampoVazio(edcodigo_barras) then
  begin
    TUtils.SetErroClass('lbcodigo_barras', 'Preencha o código de barras!');
    Exit;
  end;
    
  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    TUtils.ChamarDivLoading;
    SetDadosAlterados;
  
    if FInserting then
    begin
      lJson := GetJsonInsert;
      lJson['operacao'] := 'insert';
    end
    else
    begin
      lJson := GetJsonUpdate;

      if TJSJSON.stringify(lJson) = '{}' then
      begin
         TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Não existem dados para serem alterados!');
         Exit;
      end;

      lJson['operacao'] := 'update';
    end;

    XDataWebClientGerenciarProdutos.RawInvoke('IService.SetFsProduto', [lJson]);
  end;
end;


procedure TFViewFs_Prod_ProdutosEdit.CarregarImagemProduto;
var
  lImagem : string;
begin
  lImagem := Fs_Prod_ProdutosDataset.FieldByName('imagem').AsString;

  if (lImagem = '') or (lImagem.ToUpper = 'NULL') then
    imgProduto.url := 'assets/img/produto_sem_imagem.webp'
  else
    imgProduto.url := lImagem;
end;

procedure TFViewFs_Prod_ProdutosEdit.cbExcluidoClick(Sender: TObject);
begin
  Fs_Prod_ProdutosDataset.FieldByName('excluido').AsBoolean := cbExcluido.Checked;
end;

procedure TFViewFs_Prod_ProdutosEdit.cbPageSizeCaracteristicasChange(
  Sender: TObject);
begin
  FGridPluginCaracteristicas.SetPageSize(StrToInt(cbPageSizeCaracteristicas.Text), True);
end;

procedure TFViewFs_Prod_ProdutosEdit.cdsCaracteristicasAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
  end;

  ReiniciarCaracteristica;
  FGridPluginCaracteristicas.Load;
end;

class function TFViewFs_Prod_ProdutosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewFs_Prod_ProdutosEdit.edcodigo_barrasClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbcodigo_barras');
end;

procedure TFViewFs_Prod_ProdutosEdit.edcodigo_barrasKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9', '.']) Then
    key := #0;
end;

procedure TFViewFs_Prod_ProdutosEdit.ednomeClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbnome');
end;

procedure TFViewFs_Prod_ProdutosEdit.edSearchCaracteristicasKeyDown(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCaracteristicas.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginCaracteristicas.SetFilterText(edSearchCaracteristicas.Text, True);
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.edSearchCaracteristicasKeyUp(
  Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  tmrConsultaCaracteristicas.Interval := FTimerConsulta;
  tmrConsultaCaracteristicas.Enabled := True;
end;

procedure TFViewFs_Prod_ProdutosEdit.edtValorClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbvalor');
end;

procedure TFViewFs_Prod_ProdutosEdit.ExibirMensagemInformacao(
  const pMensagem: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, pMensagem);
end;

procedure TFViewFs_Prod_ProdutosEdit.InsertEntity;
begin
  Fs_Prod_ProdutosDataset.Close;
  Fs_Prod_ProdutosDataset.SetJsonData('{}');
  Fs_Prod_ProdutosDataset.Open;
  Fs_Prod_ProdutosDataset.Insert;

  cdsTributacoes.Close;
  cdsTributacoes.SetJsonData('{}');
  cdsTributacoes.Open;
  cdsTributacoes.Insert;

  cdsInformacoesAdicionais.Close;
  cdsInformacoesAdicionais.SetJsonData('{}');
  cdsInformacoesAdicionais.Open;
  cdsInformacoesAdicionais.Insert;
end;

class function TFViewFs_Prod_ProdutosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewFs_Prod_ProdutosEdit(AForm).FInserting := AInserting;
    TFViewFs_Prod_ProdutosEdit(AForm).FId := AId;
    TFViewFs_Prod_ProdutosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewFs_Prod_ProdutosEdit(AForm).InsertEntity
    else
      TFViewFs_Prod_ProdutosEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewFs_Prod_ProdutosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewFs_Prod_ProdutosEdit.LimparSelecaoSeletorImagens;
begin
  asm
    var lContainer = document.getElementById('seletorImagens');
    if (!lContainer) {
      return;
    }

    var lImagens = lContainer.querySelectorAll('img[data-img-src]');
    lImagens.forEach(function(lImg) {
      if (lImg.parentElement) {
        lImg.parentElement.style.border = '2px solid transparent';
        lImg.parentElement.style.boxShadow = 'none';
      }
    });
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Fs_Prod_ProdutosDataset.Connection.Model.DefaultSchema.FindEntityType(
      Fs_Prod_ProdutosDataset.EntitySetName
    )
  );
  XDataClientFs_Prod_ProdutosGet.Get(Fs_Prod_ProdutosDataset.EntitySetName, QueryString, FId);
end;


procedure TFViewFs_Prod_ProdutosEdit.OcultarMostrarBotaoRemoverImagem;
var
  lBotaoRemoverImagem : TJSHTMLElement;
  lSrc : string;
begin
  lBotaoRemoverImagem := TJSHTMLElement(document.getElementById('btnRemoverImagemPreview'));

  lSrc := TJSHTMLImageElement(GetImagemPreview).src.ToLower;
  
  if Pos('assets/img/produto_sem_imagem.webp', TJSHTMLImageElement(GetImagemPreview).src.ToLower) > 0 then
    lBotaoRemoverImagem.style.setProperty('display', 'none')
  else
    lBotaoRemoverImagem.style.setProperty('display', 'block');
end;

procedure TFViewFs_Prod_ProdutosEdit.ReiniciarCaracteristica;
begin
  TUtils.RemoverErroClass('lbcaracteristica');
  TUtils.RemoverErroClass('lbvalor');
  edtCaracteristica.Text := EmptyStr;
  edtCaracteristica.Tag := 0;
  edtValor.Text := EmptyStr;
end;

procedure TFViewFs_Prod_ProdutosEdit.RemoverImagem;
begin
  TJSHTMLImageElement(GetImagemPreview).src := 'assets/img/produto_sem_imagem.webp';
end;

procedure TFViewFs_Prod_ProdutosEdit.SetDadosAlterados;
begin
  SetValueOrNullInteger('categoria_id', edtCategoriaNome.tag, Fs_Prod_ProdutosDataset);
  SetValueOrNullInteger('subcategoria_id', edtSubCategoriaNome.tag, Fs_Prod_ProdutosDataset);
  SetValueOrNullInteger('departamento_id', edtDepartamentoNome.tag, Fs_Prod_ProdutosDataset);
  SetValueOrNullInteger('subdepartamento_id', edtSubDepartamentoNome.tag, Fs_Prod_ProdutosDataset);
  SetValueOrNullInteger('marca_id', edtMarcaNome.tag, Fs_Prod_ProdutosDataset);
  SetValueOrNullInteger('fabricante_id', edtFabricanteNome.tag, Fs_Prod_ProdutosDataset);

  if VerificarAtualizacaoImagem  then
  begin
    if (Pos('assets/img/produto_sem_imagem.webp', imgProduto.URL.ToLower) > 0) then
      Fs_Prod_ProdutosDataset.FieldByName('imagem').Value := null
    else
      Fs_Prod_ProdutosDataset.FieldByName('imagem').AsString := imgProduto.URL.Replace('%0A', '');
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.SetDadosVisualizacao;
begin
  edtCategoriaNome.Text := Fs_Prod_ProdutosDataset.FieldByName('categoria.nome').AsString;
  edtCategoriaNome.tag := Fs_Prod_ProdutosDataset.FieldByName('categoria_id').AsInteger;
  edtSubCategoriaNome.Text := Fs_Prod_ProdutosDataset.FieldByName('subcategoria.nome').AsString;
  edtSubCategoriaNome.tag := Fs_Prod_ProdutosDataset.FieldByName('subcategoria_id').AsInteger;
  edtDepartamentoNome.Text := Fs_Prod_ProdutosDataset.FieldByName('departamento.nome').AsString;
  edtDepartamentoNome.tag := Fs_Prod_ProdutosDataset.FieldByName('departamento_id').AsInteger;
  edtSubDepartamentoNome.Text := Fs_Prod_ProdutosDataset.FieldByName('subdepartamento.nome').AsString;
  edtSubDepartamentoNome.tag := Fs_Prod_ProdutosDataset.FieldByName('subdepartamento_id').AsInteger;
  edtMarcaNome.Text := Fs_Prod_ProdutosDataset.FieldByName('marca.nome').AsString;
  edtMarcaNome.tag := Fs_Prod_ProdutosDataset.FieldByName('marca_id').AsInteger;
  edtFabricanteNome.Text := Fs_Prod_ProdutosDataset.FieldByName('fabricante.nome').AsString;
  edtFabricanteNome.tag := Fs_Prod_ProdutosDataset.FieldByName('fabricante_id').AsInteger;

  CarregarImagemProduto;
end;

procedure TFViewFs_Prod_ProdutosEdit.SetValueOrNullInteger(pCampo: string;
  pValor: Integer; var pCds: TXDataWebDataSet);
begin
  if pValor = 0 then
    pCds.FieldByName(pCampo).Value := null
  else
    pCds.FieldByName(pCampo).AsInteger := pValor;
end;

procedure TFViewFs_Prod_ProdutosEdit.tblCaracteristicasGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: Integer;
  RecordCaracteristica : string;

  [async]
  procedure DeleteButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja ' +
      'excluir a característica <b>' + RecordCaracteristica + '</b> do produto?')) then
    begin
      cdsCaracteristicas.Locate('id', RecordId, []);
      cdsCaracteristicas.Delete;
      cdsCaracteristicas.ApplyUpdates;
    end;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblCaracteristicas.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := cdsCaracteristicas.FieldByName('id').AsInteger;
    RecordCaracteristica := cdsCaracteristicas.FieldByName('caracteristica.tipo').AsString + ': ' +
      cdsCaracteristicas.FieldByName('valor').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-trash-alt"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_excluir_caracteristica');

    if TUtils.PossuiPermissao(cdsCaracteristicas.EntitySetName.ToLower, TTipoPermissao.EXCLUIR) then
    begin
      Button.OnClick := @DeleteButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.tblCaracteristicasGetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if not Assigned(FGridPluginCaracteristicas) then
    Exit;

  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblCaracteristicas.Columns[ACol].DataField, ['valor', 'caracteristica.tipo']) of
      0, 1 : AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.tmrConsultaCaracteristicasTimer(
  Sender: TObject);
begin
  FGridPluginCaracteristicas.SetFilterText(edSearchCaracteristicas.Text, True);

  tmrConsultaCaracteristicas.Enabled := False;
  tmrConsultaCaracteristicas.Interval := FTimerConsulta;
end;

function TFViewFs_Prod_ProdutosEdit.VerificarAtualizacaoImagem: Boolean;
var
  lImagemBackup : string;
begin
  Result := False;
   
  lImagemBackup := Fs_Prod_ProdutosDataset.FieldByName('imagem').AsString;
  
  if (Pos('assets/img/produto_sem_imagem.webp', imgProduto.URL.ToLower) > 0) and ((lImagemBackup.IsEmpty) or (lImagemBackup.ToUpper = 'NULL')) then
    Exit
  else if lImagemBackup = imgProduto.URL then
    Exit
  else
    Result := True;
end;

procedure TFViewFs_Prod_ProdutosEdit.WebButton1Click(Sender: TObject);
begin
  RemoverImagem;
  OcultarMostrarBotaoRemoverImagem;
end;

procedure TFViewFs_Prod_ProdutosEdit.WebFormCreate(Sender: TObject);
begin
  FImagemSelecionada := EmptyStr;

  asm
    var lForm = this;
    var lBtnRemoverImagemPreview = document.getElementById('btnRemoverImagemPreview');
    var lImgProduto = document.getElementById('imgProdutoPreview');
    var lInputImagemComputador = document.getElementById('inputImagemComputador');

    if (lImgProduto && lInputImagemComputador) {
      lImgProduto.onclick = function(e) {
        e.preventDefault();
        lInputImagemComputador.click();
      };
    }

    if (lInputImagemComputador) {
      lInputImagemComputador.onchange = function(e) {
        var lFile = (e.target && e.target.files && e.target.files[0]) ? e.target.files[0] : null;
        if (!lFile) {
          return;
        }


        var tiposPermitidos = ['image/png', 'image/jpeg', 'image/webp'];
        var tamanhoMaximo = 1 * 1024 * 1024; // 1MB

        if (tiposPermitidos.indexOf(lFile.type) === -1) {
          lForm.ExibirMensagemInformacao('Formato de imagem inválido!<br> Formatos válidos: png | jpg | jpeg | webp');
          lInputImagemComputador.value = '';
          return;
        }

        if (lFile.size > tamanhoMaximo) {
          lForm.ExibirMensagemInformacao('Tamanho de imagem inválido!<br> Insira uma imagem de até 1MB.');
          lInputImagemComputador.value = '';
          return;
        }


        var lReader = new FileReader();
        lReader.onload = function(ev) {
          var lDataUrl = (ev && ev.target && ev.target.result) ? String(ev.target.result) : '';
          if (!lDataUrl) {
            return;
          }

          lForm.FImagemSelecionada = lDataUrl;
          lForm.LimparSelecaoSeletorImagens();

          if (lImgProduto) {
            lImgProduto.setAttribute('src', lDataUrl);
          }

          if (lBtnRemoverImagemPreview) {
            lBtnRemoverImagemPreview.style.display = 'block';
          }
        };

        lReader.readAsDataURL(lFile);
      };
    }
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.WebFormShow(Sender: TObject);
begin
  if FInserting or not TUtils.PossuiPermissao(cdsCaracteristicas.EntitySetName.ToLower,
    TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId(btnCaracteristicasTab.ElementID);
    THelperServer.RemoverElementoPorId('line-caracteristicas');
  end;

  if not TUtils.PossuiPermissao(cdsCaracteristicas.EntitySetName.ToLower,
    TTipoPermissao.INSERIR) then
  begin
    btnSalvarCaracteristica.Enabled := False;
    btnPesquisarCaracteristica.Enabled := False;
    edtValor.Enabled := False;
  end;

  if not TUtils.PossuiPermissao(cdsInformacoesAdicionais.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId(btnAdicionaisTab.ElementID);
    THelperServer.RemoverElementoPorId('line-adicionais');
  end;

  if not TUtils.PossuiPermissao(cdsTributacoes.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId('divTributacaoNcm');
    THelperServer.RemoverElementoPorId('divTributacaoCest');
  end;

  if FInserting then
  begin
    if not TUtils.PossuiPermissao(cdsTributacoes.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
    begin
      edncm.Enabled := False;
      edcest.Enabled := False;
    end;

    if not TUtils.PossuiPermissao(cdsInformacoesAdicionais.EntitySetName.ToLower, TTipoPermissao.INSERIR) then
      TUtils.BloquearCamposDiv('camposFormAdicionais');

    THelperServer.RemoverDiv('campos-controle');
    imgProduto.url := 'assets/img/produto_sem_imagem.webp';
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.XDataClientFs_Prod_ProdutosGetLoad(Response: TXDataClientResponse);
begin
  Fs_Prod_ProdutosDataset.Close;
  Fs_Prod_ProdutosDataset.SetJsonData(Response.Result);
  Fs_Prod_ProdutosDataset.Open;

  Fs_Prod_ProdutosDataset.Edit;

  cdsTributacoes.Close;
  cdsTributacoes.SetJsonData(Fs_Prod_ProdutosDataset.FieldByName('tributacao').value);
  cdsTributacoes.Open;

  cdsTributacoes.Edit;

  cdsInformacoesAdicionais.Close;
  cdsInformacoesAdicionais.SetJsonData(Fs_Prod_ProdutosDataset.FieldByName('adicional').value);
  cdsInformacoesAdicionais.Open;

  cdsInformacoesAdicionais.Edit;

  SetDadosVisualizacao;

  if not TUtils.PossuiPermissao(Fs_Prod_ProdutosDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
  begin
    btSave.Enabled := False;

    asm
      window.setTimeout(function() {
        pas.UUtils.TUtils.BloquearCamposDiv('camposFormProdutos', true);
        pas.UUtils.TUtils.BloquearCamposDiv('camposFormAdicionais');
      }, 200);
    end;

    btnAlterarImagem.Enabled := False;
  end
  else
  begin
    if not TUtils.PossuiPermissao(cdsTributacoes.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      edncm.Enabled := False;
      edcest.Enabled := False;
    end;

    if not TUtils.PossuiPermissao(cdsInformacoesAdicionais.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      asm
        window.setTimeout(function() {
          pas.UUtils.TUtils.BloquearCamposDiv('camposFormAdicionais');
        }, 200);
      end;
    end;
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.XDataWebClientGerenciarProdutosError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewFs_Prod_ProdutosEdit.XDataWebClientGerenciarProdutosLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewFs_Prod_ProdutosEdit.XDataWebSugestaoImagemError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewFs_Prod_ProdutosEdit.XDataWebSugestaoImagemLoad(
  Response: TXDataClientResponse);
var
  lSeletorImagens: TJSHTMLElement;
  lJsonObject: TJSObject;
  lArray, lArrayImagens: TJSArray;
  lIndice, lIndiceImagem, lQuantidadeImagens: Integer;
  lImagem, lHtmlImagens: string;
begin
  TUtils.OcultarDivLoading;

  lSeletorImagens := TJSHTMLElement(Document.getElementById('seletorImagens'));
  if not Assigned(lSeletorImagens) then
    Exit;

  lSeletorImagens.innerHTML := EmptyStr;
  lArray := Response.ResultAsArray;

  if (not Assigned(lArray)) or (lArray.Length = 0) then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhuma imagem foi encontrada!' + sLineBreak + 'Tente novamente usando outro nome.');
    Exit;
  end;

  lQuantidadeImagens := 0;
  lHtmlImagens := '<div class="card mt-3" style="border:1px solid #dee2e6;">' + '<div class="card-header bg-light"><strong>Imagens encontradas (__QTD__)</strong></div>' + '<div class="card-body"><div style="display:flex;flex-wrap:wrap;gap:12px;">';

  for lIndice := 0 to lArray.Length - 1 do
  begin
    lJsonObject := TJSObject(lArray[lIndice]);
    if not JS.isArray(lJsonObject['imagens']) then
      Continue;

    lArrayImagens := TJSArray(lJsonObject['imagens']);

    for lIndiceImagem := 0 to lArrayImagens.Length - 1 do
    begin
      lImagem := Trim(string(lArrayImagens[lIndiceImagem]));

      if lImagem.IsEmpty or SameText(lImagem, 'null') or SameText(lImagem, 'undefined') then
        Continue;

      Inc(lQuantidadeImagens);

      lHtmlImagens := lHtmlImagens + '<div class="card" style="width:112px;padding:5px;border:2px solid transparent;border-radius:8px;cursor:pointer;">' +
      '<img src="' + lImagem + '" data-img-src="' + lImagem + '"style="width:100px;height:100px;object-fit:cover;border-radius:6px;display:block;"' +
      ' onerror="this.parentElement.style.display=''none''" /></div>';
    end;
  end;

  lHtmlImagens := lHtmlImagens + '</div></div></div>';
  lHtmlImagens := StringReplace(lHtmlImagens, '__QTD__', IntToStr(lQuantidadeImagens), []);

  if Pos('<img', lHtmlImagens) > 0 then
  begin
    lSeletorImagens.innerHTML := lHtmlImagens;
    asm
      var lForm = this;
      var lContainer = document.getElementById('seletorImagens');
      if (lContainer) {
        var lImagens = lContainer.querySelectorAll('img[data-img-src]');
        lImagens.forEach(function(lImg) {
          lImg.onclick = function() {
            lImagens.forEach(function(lOutro) {
              if (lOutro.parentElement) {
                lOutro.parentElement.style.border = '2px solid transparent';
                lOutro.parentElement.style.boxShadow = 'none';
              }
            });

            if (lImg.parentElement) {
              lImg.parentElement.style.border = '2px solid #0d6efd';
              lImg.parentElement.style.boxShadow = '0 0 0 2px rgba(13,110,253,0.2)';
            }

            lForm.FImagemSelecionada = lImg.getAttribute('data-img-src') || '';

            var lImgProduto = document.getElementById('imgProdutoPreview');
            if (lImgProduto && lForm.FImagemSelecionada) {
              lImgProduto.setAttribute('src', lForm.FImagemSelecionada);
            }

            var lBtnRemoverImagemPreview = document.getElementById('btnRemoverImagemPreview');
            if (lBtnRemoverImagemPreview && lForm.FImagemSelecionada) {
              lBtnRemoverImagemPreview.style.display = 'block';
            }
          };
        });
      }
    end;
  end
  else
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, 'Nenhuma imagem foi encontrada!' + sLineBreak + 'Tente novamente usando outro nome.');
end;

function TFViewFs_Prod_ProdutosEdit.GetImagemPreview: TJSHTMLElement;
begin
  Result := TJSHTMLElement(document.getElementById('imgProdutoPreview'));
end;

function TFViewFs_Prod_ProdutosEdit.GetJsonInsert: TJSObject;
begin
  Result := TJSObject.New;

  Result['fs_prod_produtos'] := Fs_Prod_ProdutosDataset.CurrentData;

  if not(Trim(edncm.Text).IsEmpty) or not(Trim(edncm.Text).IsEmpty) then
    Result['fs_prod_tributacoes'] := cdsTributacoes.CurrentData;

  if not(Trim(eddescricao.Text).IsEmpty) or not(Trim(eddescricao_sem_tag.Text).IsEmpty) or
    not(Trim(edinfo_nutricional_json.Text).IsEmpty) or not(Trim(edficha_tecnica.Text).IsEmpty) then
  begin
    Result['fs_prod_informacoes_adicionais'] := cdsInformacoesAdicionais.CurrentData;
  end;
end;

function TFViewFs_Prod_ProdutosEdit.GetJsonUpdate: TJSObject;
var
  lJsonProduto,
  lJsonTributacao,
  lJsonInfoAdicionais : TJSObject;
  lIndice : Integer;
  lField : TField;
begin
  Result := TJSObject.New;
  lJsonProduto := TJSObject.New;
  lJsonTributacao := TJSObject.New;
  lJsonInfoAdicionais := TJSObject.New;

  for lIndice := 0 to Fs_Prod_ProdutosDataset.Fields.Count - 1 do
  begin
    lField := Fs_Prod_ProdutosDataset.Fields[lIndice];

    if lField.Tag = 1 then
      Continue;

    if lField.OldValue <> lField.NewValue then
      lJsonProduto[lField.FieldName] := lField.NewValue;
  end;

  for lIndice := 0 to cdsTributacoes.Fields.Count - 1 do
  begin
    lField := cdsTributacoes.Fields[lIndice];

    if lField.OldValue <> lField.NewValue then
      lJsonTributacao[lField.FieldName] := lField.NewValue;
  end;

  for lIndice := 0 to cdsInformacoesAdicionais.Fields.Count - 1 do
  begin
    lField := cdsInformacoesAdicionais.Fields[lIndice];

    if lField.OldValue <> lField.NewValue then
      lJsonInfoAdicionais[lField.FieldName] := lField.NewValue;
  end;

  if TJSJSON.stringify(lJsonProduto) <> '{}' then
  begin
    if Trim(edcodigo_barras.Text) = Trim(Fs_Prod_ProdutosDataset.FieldByName('codigo_barras').AsString) then
      lJsonProduto['codigo_barras'] := Trim(edcodigo_barras.Text);

    lJsonProduto['id'] := Fs_Prod_ProdutosDataset.FieldByName('id').AsInteger;
    Result['fs_prod_produtos'] := lJsonProduto;
  end;

  if TJSJSON.stringify(lJsonTributacao) <> '{}' then
  begin
    if cdsTributacoes.FieldByName('id').AsInteger > 0 then
      lJsonTributacao['id'] := cdsTributacoes.FieldByName('id').AsInteger;

    lJsonTributacao['produto_id'] := Fs_Prod_ProdutosDataset.FieldByName('id').AsInteger;
    Result['fs_prod_tributacoes'] := lJsonTributacao;
  end;

  if TJSJSON.stringify(lJsonInfoAdicionais) <> '{}' then
  begin
    if cdsInformacoesAdicionais.FieldByName('id').AsInteger > 0 then
      lJsonInfoAdicionais['id'] := cdsInformacoesAdicionais.FieldByName('id').AsInteger;

    lJsonInfoAdicionais['produto_id'] := Fs_Prod_ProdutosDataset.FieldByName('id').AsInteger;

    Result['fs_prod_informacoes_adicionais'] := lJsonInfoAdicionais;
  end;
end;

procedure TFViewFs_Prod_ProdutosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewFs_Prod_ProdutosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.fs_prod_produtos.form.lbid');
  lbnome := TLabel.Create('view.fs_prod_produtos.form.lbnome');
  lbcodigo_barras := TLabel.Create('view.fs_prod_produtos.form.lbcodigo_barras');
  lbcategoria_id := TLabel.Create('view.fs_prod_produtos.form.lbcategoria_id');
  lbsubcategoria_id := TLabel.Create('view.fs_prod_produtos.form.lbsubcategoria_id');
  lbdepartamento_id := TLabel.Create('view.fs_prod_produtos.form.lbdepartamento_id');
  lbsubdepartamento_id := TLabel.Create('view.fs_prod_produtos.form.lbsubdepartamento_id');
  lbmarca_id := TLabel.Create('view.fs_prod_produtos.form.lbmarca_id');
  lbfabricante_id := TLabel.Create('view.fs_prod_produtos.form.lbfabricante_id');
  lbcodigos := TLabel.Create('view.fs_prod_produtos.form.lbcodigos');
  lbpeso := TLabel.Create('view.fs_prod_produtos.form.lbpeso');
  lbembalagem := TLabel.Create('view.fs_prod_produtos.form.lbembalagem');
  lbquantidade_embalagem := TLabel.Create('view.fs_prod_produtos.form.lbquantidade_embalagem');
  lbexcluido := TLabel.Create('view.fs_prod_produtos.form.lbexcluido');
  lbinclusao := TLabel.Create('view.fs_prod_produtos.form.lbinclusao');
  lbalteracao := TLabel.Create('view.fs_prod_produtos.form.lbalteracao');
  lbexclusao := TLabel.Create('view.fs_prod_produtos.form.lbexclusao');
  imgProduto := TImageControl.Create('imgProduto');
  lbncm := TLabel.Create('view.fs_prod_produtos.form.lbncm');
  lbcest := TLabel.Create('view.fs_prod_produtos.form.lbcest');
  lbdescricao := TLabel.Create('view.fs_prod_produtos.form.lbdescricao');
  lbdescricao_sem_tag := TLabel.Create('view.fs_prod_produtos.form.lbdescricao_sem_tag');
  lbinfo_nutricional_json := TLabel.Create('view.fs_prod_produtos.form.lbinfo_nutricional_json');
  lbficha_tecnica := TLabel.Create('view.fs_prod_produtos.form.lbficha_tecnica');
  lbPaginationInfoCaracteristicas := TLabel.Create('lbPaginationInfoCaracteristicas');
  lblCaracteristica := TLabel.Create('lblCaracteristica');
  lblValor := TLabel.Create('lblValor');
  btCancel := TButton.Create('view.fs_prod_produtos.form.btBack');
  btSave := TButton.Create('view.fs_prod_produtos.form.btSave');
  edid := TDBEdit.Create('view.fs_prod_produtos.form.edid');
  ednome := TDBEdit.Create('view.fs_prod_produtos.form.ednome');
  edcodigo_barras := TDBEdit.Create('view.fs_prod_produtos.form.edcodigo_barras');
  edcodigos := TDBEdit.Create('view.fs_prod_produtos.form.edcodigos');
  edpeso := TDBEdit.Create('view.fs_prod_produtos.form.edpeso');
  edembalagem := TDBEdit.Create('view.fs_prod_produtos.form.edembalagem');
  edquantidade_embalagem := TDBEdit.Create('view.fs_prod_produtos.form.edquantidade_embalagem');
  edinclusao := TDBEdit.Create('view.fs_prod_produtos.form.edinclusao');
  edalteracao := TDBEdit.Create('view.fs_prod_produtos.form.edalteracao');
  edexclusao := TDBEdit.Create('view.fs_prod_produtos.form.edexclusao');
  edtCategoriaNome := TEdit.Create('edtCategoriaNome');
  btnPesquisarCategoria := TButton.Create('btnPesquisarCategoria');
  edtSubCategoriaNome := TEdit.Create('edtSubCategoriaNome');
  btnPesquisarSubCategoria := TButton.Create('btnPesquisarSubCategoria');
  edtDepartamentoNome := TEdit.Create('edtDepartamentoNome');
  btnPesquisarDepartamento := TButton.Create('btnPesquisarDepartamento');
  edtSubDepartamentoNome := TEdit.Create('edtSubDepartamentoNome');
  btnPesquisarSubDepartamento := TButton.Create('btnPesquisarSubDepartamento');
  edtMarcaNome := TEdit.Create('edtMarcaNome');
  btnPesquisarMarca := TButton.Create('btnPesquisarMarca');
  edtFabricanteNome := TEdit.Create('edtFabricanteNome');
  btnPesquisarFabricante := TButton.Create('btnPesquisarFabricante');
  cbExcluido := TDBCheckBox.Create('view.fs_prod_produtos.form.cbexcluido');
  btnDadosTab := TButton.Create('line-dados-tab');
  btnAdicionaisTab := TButton.Create('line-adicionais-tab');
  edncm := TDBEdit.Create('view.fs_prod_produtos.form.edncm');
  edcest := TDBEdit.Create('view.fs_prod_produtos.form.edcest');
  eddescricao := TDBEdit.Create('view.fs_prod_produtos.form.eddescricao');
  eddescricao_sem_tag := TDBEdit.Create('view.fs_prod_produtos.form.eddescricao_sem_tag');
  edinfo_nutricional_json := TDBEdit.Create('view.fs_prod_produtos.form.edinfo_nutricional_json');
  edficha_tecnica := TDBEdit.Create('view.fs_prod_produtos.form.edficha_tecnica');
  pnlTabelaCaracteristicas := TPanel.Create(Self);
  cbPageSizeCaracteristicas := TComboBox.Create('cbPageSizeCaracteristicas');
  edSearchCaracteristicas := TEdit.Create('edSearchCaracteristicas');
  lcPaginatorCaracteristicas := TListControl.Create('lcPaginatorCaracteristicas');
  tblCaracteristicas := TDBTableControl.Create('tblCaracteristicas');
  btnCaracteristicasTab := TButton.Create('line-caracteristicas-tab');
  edtCaracteristica := TEdit.Create('edtCaracteristica');
  btnPesquisarCaracteristica := TButton.Create('btnPesquisarCaracteristica');
  btnNovaCaracteristica := TButton.Create('btnNovaCaracteristica');
  btnSalvarCaracteristica := TButton.Create('btnSalvarCaracteristica');
  edtValor := TEdit.Create('edtValor');
  btnAlterarImagem := TButton.Create('btnAlterarImagem');
  btnPesquisarImagem := TButton.Create('btnPesquisarImagem');
  edtNomeProduto := TEdit.Create('edtNomeProduto');
  edtCodigoProduto := TEdit.Create('edtCodigoProduto');
  btnSalvarImagem := TButton.Create('btnSalvarImagem');
  btnRemoverImagemPreview := TButton.Create('btnRemoverImagemPreview');
  DataSource := TDataSource.Create(Self);
  Fs_Prod_ProdutosDataset := TXDataWebDataSet.Create(Self);
  Fs_Prod_ProdutosDatasetid := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetnome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetcodigo_barras := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetcategoria_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetsubcategoria_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetdepartamento_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetsubdepartamento_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetmarca_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetfabricante_id := TIntegerField.Create(Self);
  Fs_Prod_ProdutosDatasetcodigos := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetpeso := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetembalagem := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetquantidade_embalagem := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetfoto := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetexcluido := TBooleanField.Create(Self);
  Fs_Prod_ProdutosDatasetinclusao := TDateTimeField.Create(Self);
  Fs_Prod_ProdutosDatasetalteracao := TDateTimeField.Create(Self);
  Fs_Prod_ProdutosDatasetexclusao := TDateTimeField.Create(Self);
  Fs_Prod_ProdutosDatasetimagem := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetcategorianome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetsubcategorianome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetdepartamentonome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetsubdepartamentonome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetmarcanome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasetfabricantenome := TStringField.Create(Self);
  Fs_Prod_ProdutosDatasettributacao := TXDataWebEntityField.Create(Self);
  Fs_Prod_ProdutosDatasetadicional := TXDataWebEntityField.Create(Self);
  XDataClientFs_Prod_ProdutosGet := TXDataWebClient.Create(Self);
  cdsTributacoes := TXDataWebDataSet.Create(Self);
  dtsTributacoes := TDataSource.Create(Self);
  cdsInformacoesAdicionais := TXDataWebDataSet.Create(Self);
  cdsInformacoesAdicionaisid := TIntegerField.Create(Self);
  cdsInformacoesAdicionaisproduto_id := TIntegerField.Create(Self);
  cdsInformacoesAdicionaisdescricao := TStringField.Create(Self);
  cdsInformacoesAdicionaisdescricao_sem_tag := TStringField.Create(Self);
  cdsInformacoesAdicionaisinfo_nutricional_json := TStringField.Create(Self);
  cdsInformacoesAdicionaisficha_tecnica := TStringField.Create(Self);
  cdsInformacoesAdicionaisexcluido := TBooleanField.Create(Self);
  cdsInformacoesAdicionaisinclusao := TDateTimeField.Create(Self);
  cdsInformacoesAdicionaisalteracao := TDateTimeField.Create(Self);
  cdsInformacoesAdicionaisexclusao := TDateTimeField.Create(Self);
  dtsInformacoesAdicionais := TDataSource.Create(Self);
  XDataWebClientGerenciarProdutos := TXDataWebClient.Create(Self);
  cdsCaracteristicas := TXDataWebDataSet.Create(Self);
  cdsCaracteristicasid := TIntegerField.Create(Self);
  cdsCaracteristicasvalor := TStringField.Create(Self);
  cdsCaracteristicasproduto_id := TIntegerField.Create(Self);
  cdsCaracteristicascaracteristicatipo := TStringField.Create(Self);
  cdsCaracteristicascaracteristica_id := TIntegerField.Create(Self);
  dtsCaracteristicas := TDataSource.Create(Self);
  tmrConsultaCaracteristicas := TTimer.Create(Self);
  XDataWebSugestaoImagem := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  lbcodigo_barras.BeforeLoadDFMValues;
  lbcategoria_id.BeforeLoadDFMValues;
  lbsubcategoria_id.BeforeLoadDFMValues;
  lbdepartamento_id.BeforeLoadDFMValues;
  lbsubdepartamento_id.BeforeLoadDFMValues;
  lbmarca_id.BeforeLoadDFMValues;
  lbfabricante_id.BeforeLoadDFMValues;
  lbcodigos.BeforeLoadDFMValues;
  lbpeso.BeforeLoadDFMValues;
  lbembalagem.BeforeLoadDFMValues;
  lbquantidade_embalagem.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  imgProduto.BeforeLoadDFMValues;
  lbncm.BeforeLoadDFMValues;
  lbcest.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lbdescricao_sem_tag.BeforeLoadDFMValues;
  lbinfo_nutricional_json.BeforeLoadDFMValues;
  lbficha_tecnica.BeforeLoadDFMValues;
  lbPaginationInfoCaracteristicas.BeforeLoadDFMValues;
  lblCaracteristica.BeforeLoadDFMValues;
  lblValor.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  edcodigo_barras.BeforeLoadDFMValues;
  edcodigos.BeforeLoadDFMValues;
  edpeso.BeforeLoadDFMValues;
  edembalagem.BeforeLoadDFMValues;
  edquantidade_embalagem.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  edtCategoriaNome.BeforeLoadDFMValues;
  btnPesquisarCategoria.BeforeLoadDFMValues;
  edtSubCategoriaNome.BeforeLoadDFMValues;
  btnPesquisarSubCategoria.BeforeLoadDFMValues;
  edtDepartamentoNome.BeforeLoadDFMValues;
  btnPesquisarDepartamento.BeforeLoadDFMValues;
  edtSubDepartamentoNome.BeforeLoadDFMValues;
  btnPesquisarSubDepartamento.BeforeLoadDFMValues;
  edtMarcaNome.BeforeLoadDFMValues;
  btnPesquisarMarca.BeforeLoadDFMValues;
  edtFabricanteNome.BeforeLoadDFMValues;
  btnPesquisarFabricante.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  btnDadosTab.BeforeLoadDFMValues;
  btnAdicionaisTab.BeforeLoadDFMValues;
  edncm.BeforeLoadDFMValues;
  edcest.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  eddescricao_sem_tag.BeforeLoadDFMValues;
  edinfo_nutricional_json.BeforeLoadDFMValues;
  edficha_tecnica.BeforeLoadDFMValues;
  pnlTabelaCaracteristicas.BeforeLoadDFMValues;
  cbPageSizeCaracteristicas.BeforeLoadDFMValues;
  edSearchCaracteristicas.BeforeLoadDFMValues;
  lcPaginatorCaracteristicas.BeforeLoadDFMValues;
  tblCaracteristicas.BeforeLoadDFMValues;
  btnCaracteristicasTab.BeforeLoadDFMValues;
  edtCaracteristica.BeforeLoadDFMValues;
  btnPesquisarCaracteristica.BeforeLoadDFMValues;
  btnNovaCaracteristica.BeforeLoadDFMValues;
  btnSalvarCaracteristica.BeforeLoadDFMValues;
  edtValor.BeforeLoadDFMValues;
  btnAlterarImagem.BeforeLoadDFMValues;
  btnPesquisarImagem.BeforeLoadDFMValues;
  edtNomeProduto.BeforeLoadDFMValues;
  edtCodigoProduto.BeforeLoadDFMValues;
  btnSalvarImagem.BeforeLoadDFMValues;
  btnRemoverImagemPreview.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDataset.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetid.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetnome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetcodigo_barras.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetcategoria_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetsubcategoria_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetdepartamento_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetsubdepartamento_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetmarca_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetfabricante_id.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetcodigos.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetpeso.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetembalagem.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetquantidade_embalagem.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetfoto.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetexcluido.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetinclusao.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetalteracao.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetexclusao.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetimagem.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetcategorianome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetsubcategorianome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetdepartamentonome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetsubdepartamentonome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetmarcanome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetfabricantenome.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasettributacao.BeforeLoadDFMValues;
  Fs_Prod_ProdutosDatasetadicional.BeforeLoadDFMValues;
  XDataClientFs_Prod_ProdutosGet.BeforeLoadDFMValues;
  cdsTributacoes.BeforeLoadDFMValues;
  dtsTributacoes.BeforeLoadDFMValues;
  cdsInformacoesAdicionais.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisid.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisproduto_id.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisdescricao.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisdescricao_sem_tag.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisinfo_nutricional_json.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisficha_tecnica.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisexcluido.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisinclusao.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisalteracao.BeforeLoadDFMValues;
  cdsInformacoesAdicionaisexclusao.BeforeLoadDFMValues;
  dtsInformacoesAdicionais.BeforeLoadDFMValues;
  XDataWebClientGerenciarProdutos.BeforeLoadDFMValues;
  cdsCaracteristicas.BeforeLoadDFMValues;
  cdsCaracteristicasid.BeforeLoadDFMValues;
  cdsCaracteristicasvalor.BeforeLoadDFMValues;
  cdsCaracteristicasproduto_id.BeforeLoadDFMValues;
  cdsCaracteristicascaracteristicatipo.BeforeLoadDFMValues;
  cdsCaracteristicascaracteristica_id.BeforeLoadDFMValues;
  dtsCaracteristicas.BeforeLoadDFMValues;
  tmrConsultaCaracteristicas.BeforeLoadDFMValues;
  XDataWebSugestaoImagem.BeforeLoadDFMValues;
  try
    Name := 'FViewFs_Prod_ProdutosEdit';
    Width := 946;
    Height := 652;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 16;
    lbid.Top := 16;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 16;
    lbnome.Top := 43;
    lbnome.Width := 31;
    lbnome.Height := 13;
    lbnome.Caption := 'Nome:';
    lbnome.HeightPercent := 100.000000000000000000;
    lbnome.WidthPercent := 100.000000000000000000;
    lbcodigo_barras.SetParentComponent(Self);
    lbcodigo_barras.Name := 'lbcodigo_barras';
    lbcodigo_barras.Left := 16;
    lbcodigo_barras.Top := 70;
    lbcodigo_barras.Width := 61;
    lbcodigo_barras.Height := 13;
    lbcodigo_barras.Caption := 'C'#243'd. Barras:';
    lbcodigo_barras.HeightPercent := 100.000000000000000000;
    lbcodigo_barras.WidthPercent := 100.000000000000000000;
    lbcategoria_id.SetParentComponent(Self);
    lbcategoria_id.Name := 'lbcategoria_id';
    lbcategoria_id.Left := 16;
    lbcategoria_id.Top := 97;
    lbcategoria_id.Width := 51;
    lbcategoria_id.Height := 13;
    lbcategoria_id.Caption := 'Categoria:';
    lbcategoria_id.HeightPercent := 100.000000000000000000;
    lbcategoria_id.WidthPercent := 100.000000000000000000;
    lbsubcategoria_id.SetParentComponent(Self);
    lbsubcategoria_id.Name := 'lbsubcategoria_id';
    lbsubcategoria_id.Left := 16;
    lbsubcategoria_id.Top := 124;
    lbsubcategoria_id.Width := 69;
    lbsubcategoria_id.Height := 13;
    lbsubcategoria_id.Caption := 'SubCategoria:';
    lbsubcategoria_id.HeightPercent := 100.000000000000000000;
    lbsubcategoria_id.WidthPercent := 100.000000000000000000;
    lbdepartamento_id.SetParentComponent(Self);
    lbdepartamento_id.Name := 'lbdepartamento_id';
    lbdepartamento_id.Left := 16;
    lbdepartamento_id.Top := 151;
    lbdepartamento_id.Width := 73;
    lbdepartamento_id.Height := 13;
    lbdepartamento_id.Caption := 'Departamento:';
    lbdepartamento_id.HeightPercent := 100.000000000000000000;
    lbdepartamento_id.WidthPercent := 100.000000000000000000;
    lbsubdepartamento_id.SetParentComponent(Self);
    lbsubdepartamento_id.Name := 'lbsubdepartamento_id';
    lbsubdepartamento_id.Left := 16;
    lbsubdepartamento_id.Top := 178;
    lbsubdepartamento_id.Width := 91;
    lbsubdepartamento_id.Height := 13;
    lbsubdepartamento_id.Caption := 'SubDepartamento:';
    lbsubdepartamento_id.HeightPercent := 100.000000000000000000;
    lbsubdepartamento_id.WidthPercent := 100.000000000000000000;
    lbmarca_id.SetParentComponent(Self);
    lbmarca_id.Name := 'lbmarca_id';
    lbmarca_id.Left := 16;
    lbmarca_id.Top := 205;
    lbmarca_id.Width := 33;
    lbmarca_id.Height := 13;
    lbmarca_id.Caption := 'Marca:';
    lbmarca_id.HeightPercent := 100.000000000000000000;
    lbmarca_id.WidthPercent := 100.000000000000000000;
    lbfabricante_id.SetParentComponent(Self);
    lbfabricante_id.Name := 'lbfabricante_id';
    lbfabricante_id.Left := 16;
    lbfabricante_id.Top := 232;
    lbfabricante_id.Width := 55;
    lbfabricante_id.Height := 13;
    lbfabricante_id.Caption := 'Fabricante:';
    lbfabricante_id.HeightPercent := 100.000000000000000000;
    lbfabricante_id.WidthPercent := 100.000000000000000000;
    lbcodigos.SetParentComponent(Self);
    lbcodigos.Name := 'lbcodigos';
    lbcodigos.Left := 338;
    lbcodigos.Top := 16;
    lbcodigos.Width := 83;
    lbcodigos.Height := 13;
    lbcodigos.Caption := 'C'#243'd. Alternativo:';
    lbcodigos.HeightPercent := 100.000000000000000000;
    lbcodigos.WidthPercent := 100.000000000000000000;
    lbpeso.SetParentComponent(Self);
    lbpeso.Name := 'lbpeso';
    lbpeso.Left := 338;
    lbpeso.Top := 43;
    lbpeso.Width := 27;
    lbpeso.Height := 13;
    lbpeso.Caption := 'Peso:';
    lbpeso.HeightPercent := 100.000000000000000000;
    lbpeso.WidthPercent := 100.000000000000000000;
    lbembalagem.SetParentComponent(Self);
    lbembalagem.Name := 'lbembalagem';
    lbembalagem.Left := 338;
    lbembalagem.Top := 70;
    lbembalagem.Width := 58;
    lbembalagem.Height := 13;
    lbembalagem.Caption := 'Embalagem:';
    lbembalagem.HeightPercent := 100.000000000000000000;
    lbembalagem.WidthPercent := 100.000000000000000000;
    lbquantidade_embalagem.SetParentComponent(Self);
    lbquantidade_embalagem.Name := 'lbquantidade_embalagem';
    lbquantidade_embalagem.Left := 338;
    lbquantidade_embalagem.Top := 97;
    lbquantidade_embalagem.Width := 89;
    lbquantidade_embalagem.Height := 13;
    lbquantidade_embalagem.Caption := 'Qtde. Embalagem:';
    lbquantidade_embalagem.HeightPercent := 100.000000000000000000;
    lbquantidade_embalagem.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 338;
    lbexcluido.Top := 124;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 338;
    lbinclusao.Top := 151;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 338;
    lbalteracao.Top := 178;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 338;
    lbexclusao.Top := 205;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    imgProduto.SetParentComponent(Self);
    imgProduto.Name := 'imgProduto';
    imgProduto.Left := 338;
    imgProduto.Top := 338;
    imgProduto.Width := 99;
    imgProduto.Height := 41;
    imgProduto.HeightPercent := 100.000000000000000000;
    imgProduto.WidthPercent := 100.000000000000000000;
    imgProduto.ChildOrder := 44;
    lbncm.SetParentComponent(Self);
    lbncm.Name := 'lbncm';
    lbncm.Left := 16;
    lbncm.Top := 262;
    lbncm.Width := 24;
    lbncm.Height := 13;
    lbncm.Caption := 'Ncm:';
    lbncm.HeightPercent := 100.000000000000000000;
    lbncm.WidthPercent := 100.000000000000000000;
    lbcest.SetParentComponent(Self);
    lbcest.Name := 'lbcest';
    lbcest.Left := 16;
    lbcest.Top := 289;
    lbcest.Width := 26;
    lbcest.Height := 13;
    lbcest.Caption := 'Cest:';
    lbcest.HeightPercent := 100.000000000000000000;
    lbcest.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 16;
    lbdescricao.Top := 317;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lbdescricao_sem_tag.SetParentComponent(Self);
    lbdescricao_sem_tag.Name := 'lbdescricao_sem_tag';
    lbdescricao_sem_tag.Left := 337;
    lbdescricao_sem_tag.Top := 232;
    lbdescricao_sem_tag.Width := 94;
    lbdescricao_sem_tag.Height := 13;
    lbdescricao_sem_tag.Caption := 'Descri'#231#227'o Sem Tag:';
    lbdescricao_sem_tag.HeightPercent := 100.000000000000000000;
    lbdescricao_sem_tag.WidthPercent := 100.000000000000000000;
    lbinfo_nutricional_json.SetParentComponent(Self);
    lbinfo_nutricional_json.Name := 'lbinfo_nutricional_json';
    lbinfo_nutricional_json.Left := 337;
    lbinfo_nutricional_json.Top := 262;
    lbinfo_nutricional_json.Width := 81;
    lbinfo_nutricional_json.Height := 13;
    lbinfo_nutricional_json.Caption := 'Info. Nutricional:';
    lbinfo_nutricional_json.HeightPercent := 100.000000000000000000;
    lbinfo_nutricional_json.WidthPercent := 100.000000000000000000;
    lbficha_tecnica.SetParentComponent(Self);
    lbficha_tecnica.Name := 'lbficha_tecnica';
    lbficha_tecnica.Left := 337;
    lbficha_tecnica.Top := 289;
    lbficha_tecnica.Width := 68;
    lbficha_tecnica.Height := 13;
    lbficha_tecnica.Caption := 'Ficha T'#233'cnica:';
    lbficha_tecnica.HeightPercent := 100.000000000000000000;
    lbficha_tecnica.WidthPercent := 100.000000000000000000;
    lbPaginationInfoCaracteristicas.SetParentComponent(Self);
    lbPaginationInfoCaracteristicas.Name := 'lbPaginationInfoCaracteristicas';
    lbPaginationInfoCaracteristicas.Left := 22;
    lbPaginationInfoCaracteristicas.Top := 602;
    lbPaginationInfoCaracteristicas.Width := 141;
    lbPaginationInfoCaracteristicas.Height := 13;
    lbPaginationInfoCaracteristicas.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfoCaracteristicas.HeightPercent := 100.000000000000000000;
    lbPaginationInfoCaracteristicas.WidthPercent := 100.000000000000000000;
    lblCaracteristica.SetParentComponent(Self);
    lblCaracteristica.Name := 'lblCaracteristica';
    lblCaracteristica.Left := 304;
    lblCaracteristica.Top := 422;
    lblCaracteristica.Width := 70;
    lblCaracteristica.Height := 13;
    lblCaracteristica.Caption := 'Caracter'#237'stica:';
    lblCaracteristica.HeightPercent := 100.000000000000000000;
    lblCaracteristica.WidthPercent := 100.000000000000000000;
    lblValor.SetParentComponent(Self);
    lblValor.Name := 'lblValor';
    lblValor.Left := 304;
    lblValor.Top := 450;
    lblValor.Width := 28;
    lblValor.Height := 13;
    lblValor.Caption := 'Valor:';
    lblValor.HeightPercent := 100.000000000000000000;
    lblValor.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 758;
    btCancel.Top := 305;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancelar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 758;
    btSave.Top := 277;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 149;
    edid.Top := 13;
    edid.Width := 151;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 5;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 149;
    ednome.Top := 40;
    ednome.Width := 151;
    ednome.Height := 21;
    ednome.HeightPercent := 100.000000000000000000;
    ednome.MaxLength := 255;
    ednome.TabOrder := 6;
    ednome.Text := 'ednome';
    ednome.WidthPercent := 100.000000000000000000;
    SetEvent(ednome, Self, 'OnClick', 'ednomeClick');
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    edcodigo_barras.SetParentComponent(Self);
    edcodigo_barras.Name := 'edcodigo_barras';
    edcodigo_barras.Left := 149;
    edcodigo_barras.Top := 67;
    edcodigo_barras.Width := 151;
    edcodigo_barras.Height := 21;
    edcodigo_barras.HeightPercent := 100.000000000000000000;
    edcodigo_barras.MaxLength := 30;
    edcodigo_barras.TabOrder := 7;
    edcodigo_barras.Text := 'edcodigo_barras';
    edcodigo_barras.WidthPercent := 100.000000000000000000;
    SetEvent(edcodigo_barras, Self, 'OnClick', 'edcodigo_barrasClick');
    SetEvent(edcodigo_barras, Self, 'OnKeyPress', 'edcodigo_barrasKeyPress');
    edcodigo_barras.DataField := 'codigo_barras';
    edcodigo_barras.DataSource := DataSource;
    edcodigos.SetParentComponent(Self);
    edcodigos.Name := 'edcodigos';
    edcodigos.Left := 487;
    edcodigos.Top := 13;
    edcodigos.Width := 151;
    edcodigos.Height := 21;
    edcodigos.HeightPercent := 100.000000000000000000;
    edcodigos.MaxLength := 255;
    edcodigos.TabOrder := 14;
    edcodigos.Text := 'edcodigos';
    edcodigos.WidthPercent := 100.000000000000000000;
    edcodigos.DataField := 'codigos';
    edcodigos.DataSource := DataSource;
    edpeso.SetParentComponent(Self);
    edpeso.Name := 'edpeso';
    edpeso.Left := 487;
    edpeso.Top := 40;
    edpeso.Width := 151;
    edpeso.Height := 21;
    edpeso.HeightPercent := 100.000000000000000000;
    edpeso.MaxLength := 100;
    edpeso.TabOrder := 15;
    edpeso.Text := 'edpeso';
    edpeso.WidthPercent := 100.000000000000000000;
    edpeso.DataField := 'peso';
    edpeso.DataSource := DataSource;
    edembalagem.SetParentComponent(Self);
    edembalagem.Name := 'edembalagem';
    edembalagem.Left := 487;
    edembalagem.Top := 67;
    edembalagem.Width := 151;
    edembalagem.Height := 21;
    edembalagem.HeightPercent := 100.000000000000000000;
    edembalagem.MaxLength := 100;
    edembalagem.TabOrder := 16;
    edembalagem.Text := 'edembalagem';
    edembalagem.WidthPercent := 100.000000000000000000;
    edembalagem.DataField := 'embalagem';
    edembalagem.DataSource := DataSource;
    edquantidade_embalagem.SetParentComponent(Self);
    edquantidade_embalagem.Name := 'edquantidade_embalagem';
    edquantidade_embalagem.Left := 487;
    edquantidade_embalagem.Top := 94;
    edquantidade_embalagem.Width := 151;
    edquantidade_embalagem.Height := 21;
    edquantidade_embalagem.HeightPercent := 100.000000000000000000;
    edquantidade_embalagem.MaxLength := 100;
    edquantidade_embalagem.TabOrder := 17;
    edquantidade_embalagem.Text := 'edquantidade_embalagem';
    edquantidade_embalagem.WidthPercent := 100.000000000000000000;
    SetEvent(edquantidade_embalagem, Self, 'OnKeyPress', 'edcodigo_barrasKeyPress');
    edquantidade_embalagem.DataField := 'quantidade_embalagem';
    edquantidade_embalagem.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 487;
    edinclusao.Top := 148;
    edinclusao.Width := 151;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 20;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 487;
    edalteracao.Top := 175;
    edalteracao.Width := 151;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 21;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 487;
    edexclusao.Top := 202;
    edexclusao.Width := 151;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 22;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    edtCategoriaNome.SetParentComponent(Self);
    edtCategoriaNome.Name := 'edtCategoriaNome';
    edtCategoriaNome.Left := 149;
    edtCategoriaNome.Top := 94;
    edtCategoriaNome.Width := 120;
    edtCategoriaNome.Height := 22;
    edtCategoriaNome.ChildOrder := 21;
    edtCategoriaNome.Enabled := False;
    edtCategoriaNome.HeightPercent := 100.000000000000000000;
    edtCategoriaNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCategoria.SetParentComponent(Self);
    btnPesquisarCategoria.Name := 'btnPesquisarCategoria';
    btnPesquisarCategoria.Left := 270;
    btnPesquisarCategoria.Top := 94;
    btnPesquisarCategoria.Width := 30;
    btnPesquisarCategoria.Height := 22;
    btnPesquisarCategoria.ChildOrder := 22;
    btnPesquisarCategoria.HeightPercent := 100.000000000000000000;
    btnPesquisarCategoria.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCategoria, Self, 'OnClick', 'btnPesquisarCategoriaClick');
    edtSubCategoriaNome.SetParentComponent(Self);
    edtSubCategoriaNome.Name := 'edtSubCategoriaNome';
    edtSubCategoriaNome.Left := 149;
    edtSubCategoriaNome.Top := 121;
    edtSubCategoriaNome.Width := 120;
    edtSubCategoriaNome.Height := 22;
    edtSubCategoriaNome.ChildOrder := 21;
    edtSubCategoriaNome.Enabled := False;
    edtSubCategoriaNome.HeightPercent := 100.000000000000000000;
    edtSubCategoriaNome.WidthPercent := 100.000000000000000000;
    btnPesquisarSubCategoria.SetParentComponent(Self);
    btnPesquisarSubCategoria.Name := 'btnPesquisarSubCategoria';
    btnPesquisarSubCategoria.Left := 270;
    btnPesquisarSubCategoria.Top := 121;
    btnPesquisarSubCategoria.Width := 30;
    btnPesquisarSubCategoria.Height := 22;
    btnPesquisarSubCategoria.ChildOrder := 22;
    btnPesquisarSubCategoria.HeightPercent := 100.000000000000000000;
    btnPesquisarSubCategoria.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarSubCategoria, Self, 'OnClick', 'btnPesquisarSubCategoriaClick');
    edtDepartamentoNome.SetParentComponent(Self);
    edtDepartamentoNome.Name := 'edtDepartamentoNome';
    edtDepartamentoNome.Left := 149;
    edtDepartamentoNome.Top := 148;
    edtDepartamentoNome.Width := 120;
    edtDepartamentoNome.Height := 22;
    edtDepartamentoNome.ChildOrder := 21;
    edtDepartamentoNome.Enabled := False;
    edtDepartamentoNome.HeightPercent := 100.000000000000000000;
    edtDepartamentoNome.WidthPercent := 100.000000000000000000;
    btnPesquisarDepartamento.SetParentComponent(Self);
    btnPesquisarDepartamento.Name := 'btnPesquisarDepartamento';
    btnPesquisarDepartamento.Left := 270;
    btnPesquisarDepartamento.Top := 148;
    btnPesquisarDepartamento.Width := 30;
    btnPesquisarDepartamento.Height := 22;
    btnPesquisarDepartamento.ChildOrder := 22;
    btnPesquisarDepartamento.HeightPercent := 100.000000000000000000;
    btnPesquisarDepartamento.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarDepartamento, Self, 'OnClick', 'btnPesquisarDepartamentoClick');
    edtSubDepartamentoNome.SetParentComponent(Self);
    edtSubDepartamentoNome.Name := 'edtSubDepartamentoNome';
    edtSubDepartamentoNome.Left := 149;
    edtSubDepartamentoNome.Top := 175;
    edtSubDepartamentoNome.Width := 120;
    edtSubDepartamentoNome.Height := 22;
    edtSubDepartamentoNome.ChildOrder := 21;
    edtSubDepartamentoNome.Enabled := False;
    edtSubDepartamentoNome.HeightPercent := 100.000000000000000000;
    edtSubDepartamentoNome.WidthPercent := 100.000000000000000000;
    btnPesquisarSubDepartamento.SetParentComponent(Self);
    btnPesquisarSubDepartamento.Name := 'btnPesquisarSubDepartamento';
    btnPesquisarSubDepartamento.Left := 270;
    btnPesquisarSubDepartamento.Top := 175;
    btnPesquisarSubDepartamento.Width := 30;
    btnPesquisarSubDepartamento.Height := 22;
    btnPesquisarSubDepartamento.ChildOrder := 22;
    btnPesquisarSubDepartamento.HeightPercent := 100.000000000000000000;
    btnPesquisarSubDepartamento.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarSubDepartamento, Self, 'OnClick', 'btnPesquisarSubDepartamentoClick');
    edtMarcaNome.SetParentComponent(Self);
    edtMarcaNome.Name := 'edtMarcaNome';
    edtMarcaNome.Left := 149;
    edtMarcaNome.Top := 202;
    edtMarcaNome.Width := 120;
    edtMarcaNome.Height := 22;
    edtMarcaNome.ChildOrder := 21;
    edtMarcaNome.Enabled := False;
    edtMarcaNome.HeightPercent := 100.000000000000000000;
    edtMarcaNome.WidthPercent := 100.000000000000000000;
    btnPesquisarMarca.SetParentComponent(Self);
    btnPesquisarMarca.Name := 'btnPesquisarMarca';
    btnPesquisarMarca.Left := 270;
    btnPesquisarMarca.Top := 202;
    btnPesquisarMarca.Width := 30;
    btnPesquisarMarca.Height := 22;
    btnPesquisarMarca.ChildOrder := 22;
    btnPesquisarMarca.HeightPercent := 100.000000000000000000;
    btnPesquisarMarca.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarMarca, Self, 'OnClick', 'btnPesquisarMarcaClick');
    edtFabricanteNome.SetParentComponent(Self);
    edtFabricanteNome.Name := 'edtFabricanteNome';
    edtFabricanteNome.Left := 149;
    edtFabricanteNome.Top := 229;
    edtFabricanteNome.Width := 120;
    edtFabricanteNome.Height := 22;
    edtFabricanteNome.ChildOrder := 21;
    edtFabricanteNome.Enabled := False;
    edtFabricanteNome.HeightPercent := 100.000000000000000000;
    edtFabricanteNome.WidthPercent := 100.000000000000000000;
    btnPesquisarFabricante.SetParentComponent(Self);
    btnPesquisarFabricante.Name := 'btnPesquisarFabricante';
    btnPesquisarFabricante.Left := 270;
    btnPesquisarFabricante.Top := 229;
    btnPesquisarFabricante.Width := 30;
    btnPesquisarFabricante.Height := 22;
    btnPesquisarFabricante.ChildOrder := 22;
    btnPesquisarFabricante.HeightPercent := 100.000000000000000000;
    btnPesquisarFabricante.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarFabricante, Self, 'OnClick', 'btnPesquisarFabricanteClick');
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 487;
    cbExcluido.Top := 121;
    cbExcluido.Width := 151;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    SetEvent(cbExcluido, Self, 'OnClick', 'cbExcluidoClick');
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    btnDadosTab.SetParentComponent(Self);
    btnDadosTab.Name := 'btnDadosTab';
    btnDadosTab.Left := 656;
    btnDadosTab.Top := 277;
    btnDadosTab.Width := 96;
    btnDadosTab.Height := 25;
    btnDadosTab.Caption := 'Dados';
    btnDadosTab.ChildOrder := 16;
    btnDadosTab.HeightPercent := 100.000000000000000000;
    btnDadosTab.WidthPercent := 100.000000000000000000;
    btnAdicionaisTab.SetParentComponent(Self);
    btnAdicionaisTab.Name := 'btnAdicionaisTab';
    btnAdicionaisTab.Left := 656;
    btnAdicionaisTab.Top := 305;
    btnAdicionaisTab.Width := 96;
    btnAdicionaisTab.Height := 25;
    btnAdicionaisTab.Caption := 'Adicionais';
    btnAdicionaisTab.ChildOrder := 16;
    btnAdicionaisTab.HeightPercent := 100.000000000000000000;
    btnAdicionaisTab.WidthPercent := 100.000000000000000000;
    edncm.SetParentComponent(Self);
    edncm.Name := 'edncm';
    edncm.Left := 149;
    edncm.Top := 259;
    edncm.Width := 151;
    edncm.Height := 22;
    edncm.ChildOrder := 46;
    edncm.HeightPercent := 100.000000000000000000;
    edncm.MaxLength := 20;
    edncm.TabOrder := 6;
    edncm.WidthPercent := 100.000000000000000000;
    SetEvent(edncm, Self, 'OnKeyPress', 'edcodigo_barrasKeyPress');
    edncm.DataField := 'ncm';
    edncm.DataSource := dtsTributacoes;
    edcest.SetParentComponent(Self);
    edcest.Name := 'edcest';
    edcest.Left := 149;
    edcest.Top := 286;
    edcest.Width := 151;
    edcest.Height := 22;
    edcest.ChildOrder := 46;
    edcest.HeightPercent := 100.000000000000000000;
    edcest.MaxLength := 255;
    edcest.TabOrder := 6;
    edcest.WidthPercent := 100.000000000000000000;
    SetEvent(edcest, Self, 'OnKeyPress', 'edcodigo_barrasKeyPress');
    edcest.DataField := 'cest';
    edcest.DataSource := dtsTributacoes;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 149;
    eddescricao.Top := 314;
    eddescricao.Width := 151;
    eddescricao.Height := 22;
    eddescricao.ChildOrder := 46;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 6;
    eddescricao.WidthPercent := 100.000000000000000000;
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := dtsInformacoesAdicionais;
    eddescricao_sem_tag.SetParentComponent(Self);
    eddescricao_sem_tag.Name := 'eddescricao_sem_tag';
    eddescricao_sem_tag.Left := 487;
    eddescricao_sem_tag.Top := 229;
    eddescricao_sem_tag.Width := 151;
    eddescricao_sem_tag.Height := 22;
    eddescricao_sem_tag.ChildOrder := 46;
    eddescricao_sem_tag.HeightPercent := 100.000000000000000000;
    eddescricao_sem_tag.TabOrder := 6;
    eddescricao_sem_tag.WidthPercent := 100.000000000000000000;
    eddescricao_sem_tag.DataField := 'descricao_sem_tag';
    eddescricao_sem_tag.DataSource := dtsInformacoesAdicionais;
    edinfo_nutricional_json.SetParentComponent(Self);
    edinfo_nutricional_json.Name := 'edinfo_nutricional_json';
    edinfo_nutricional_json.Left := 487;
    edinfo_nutricional_json.Top := 259;
    edinfo_nutricional_json.Width := 151;
    edinfo_nutricional_json.Height := 22;
    edinfo_nutricional_json.ChildOrder := 46;
    edinfo_nutricional_json.HeightPercent := 100.000000000000000000;
    edinfo_nutricional_json.TabOrder := 6;
    edinfo_nutricional_json.WidthPercent := 100.000000000000000000;
    edinfo_nutricional_json.DataField := 'info_nutricional_json';
    edinfo_nutricional_json.DataSource := dtsInformacoesAdicionais;
    edficha_tecnica.SetParentComponent(Self);
    edficha_tecnica.Name := 'edficha_tecnica';
    edficha_tecnica.Left := 487;
    edficha_tecnica.Top := 286;
    edficha_tecnica.Width := 151;
    edficha_tecnica.Height := 22;
    edficha_tecnica.ChildOrder := 46;
    edficha_tecnica.HeightPercent := 100.000000000000000000;
    edficha_tecnica.TabOrder := 6;
    edficha_tecnica.WidthPercent := 100.000000000000000000;
    edficha_tecnica.DataField := 'ficha_tecnica';
    edficha_tecnica.DataSource := dtsInformacoesAdicionais;
    pnlTabelaCaracteristicas.SetParentComponent(Self);
    pnlTabelaCaracteristicas.Name := 'pnlTabelaCaracteristicas';
    pnlTabelaCaracteristicas.Left := 16;
    pnlTabelaCaracteristicas.Top := 384;
    pnlTabelaCaracteristicas.Width := 601;
    pnlTabelaCaracteristicas.Height := 17;
    pnlTabelaCaracteristicas.Caption := 'Espa'#231'o Caracteristicas';
    pnlTabelaCaracteristicas.ChildOrder := 23;
    pnlTabelaCaracteristicas.Color := clInfoText;
    pnlTabelaCaracteristicas.Font.Charset := DEFAULT_CHARSET;
    pnlTabelaCaracteristicas.Font.Color := clWhite;
    pnlTabelaCaracteristicas.Font.Height := -11;
    pnlTabelaCaracteristicas.Font.Name := 'Tahoma';
    pnlTabelaCaracteristicas.Font.Style := [fsBold];
    pnlTabelaCaracteristicas.ParentFont := False;
    pnlTabelaCaracteristicas.TabOrder := 33;
    pnlTabelaCaracteristicas.Visible := False;
    cbPageSizeCaracteristicas.SetParentComponent(Self);
    cbPageSizeCaracteristicas.Name := 'cbPageSizeCaracteristicas';
    cbPageSizeCaracteristicas.Left := 16;
    cbPageSizeCaracteristicas.Top := 419;
    cbPageSizeCaracteristicas.Width := 81;
    cbPageSizeCaracteristicas.Height := 21;
    cbPageSizeCaracteristicas.HeightPercent := 100.000000000000000000;
    cbPageSizeCaracteristicas.TabOrder := 2;
    cbPageSizeCaracteristicas.Text := '10';
    cbPageSizeCaracteristicas.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeCaracteristicas, Self, 'OnChange', 'cbPageSizeCaracteristicasChange');
    cbPageSizeCaracteristicas.ItemIndex := 0;
    cbPageSizeCaracteristicas.Items.BeginUpdate;
    try
      cbPageSizeCaracteristicas.Items.Clear;
      cbPageSizeCaracteristicas.Items.Add('10');
      cbPageSizeCaracteristicas.Items.Add('25');
      cbPageSizeCaracteristicas.Items.Add('50');
      cbPageSizeCaracteristicas.Items.Add('100');
    finally
      cbPageSizeCaracteristicas.Items.EndUpdate;
    end;
    edSearchCaracteristicas.SetParentComponent(Self);
    edSearchCaracteristicas.Name := 'edSearchCaracteristicas';
    edSearchCaracteristicas.Left := 170;
    edSearchCaracteristicas.Top := 419;
    edSearchCaracteristicas.Width := 121;
    edSearchCaracteristicas.Height := 21;
    edSearchCaracteristicas.ChildOrder := 78;
    edSearchCaracteristicas.HeightPercent := 100.000000000000000000;
    edSearchCaracteristicas.TabOrder := 3;
    edSearchCaracteristicas.WidthPercent := 100.000000000000000000;
    SetEvent(edSearchCaracteristicas, Self, 'OnKeyDown', 'edSearchCaracteristicasKeyDown');
    SetEvent(edSearchCaracteristicas, Self, 'OnKeyUp', 'edSearchCaracteristicasKeyUp');
    lcPaginatorCaracteristicas.SetParentComponent(Self);
    lcPaginatorCaracteristicas.Name := 'lcPaginatorCaracteristicas';
    lcPaginatorCaracteristicas.Left := 169;
    lcPaginatorCaracteristicas.Top := 602;
    lcPaginatorCaracteristicas.Width := 122;
    lcPaginatorCaracteristicas.Height := 25;
    lcPaginatorCaracteristicas.HeightPercent := 100.000000000000000000;
    lcPaginatorCaracteristicas.WidthPercent := 100.000000000000000000;
    lcPaginatorCaracteristicas.ChildOrder := 81;
    lcPaginatorCaracteristicas.DefaultItemClassName := 'page-item';
    lcPaginatorCaracteristicas.DefaultItemLinkClassName := 'page-link';
    lcPaginatorCaracteristicas.ElementListClassName := 'pagination';
    lcPaginatorCaracteristicas.Items.Clear;
    with lcPaginatorCaracteristicas.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginatorCaracteristicas.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginatorCaracteristicas.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginatorCaracteristicas.Style := lsPagination;
    tblCaracteristicas.SetParentComponent(Self);
    tblCaracteristicas.Name := 'tblCaracteristicas';
    tblCaracteristicas.Left := 16;
    tblCaracteristicas.Top := 446;
    tblCaracteristicas.Width := 275;
    tblCaracteristicas.Height := 150;
    tblCaracteristicas.ElementClassName := 'table-responsive';
    tblCaracteristicas.BorderColor := clSilver;
    tblCaracteristicas.ChildOrder := 82;
    tblCaracteristicas.ColHeader := False;
    tblCaracteristicas.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblCaracteristicas, Self, 'OnGetCellChildren', 'tblCaracteristicasGetCellChildren');
    SetEvent(tblCaracteristicas, Self, 'OnGetCellClass', 'tblCaracteristicasGetCellClass');
    tblCaracteristicas.Columns.Clear;
    with tblCaracteristicas.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblCaracteristicas.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with tblCaracteristicas.Columns.Add do
    begin
      DataField := 'caracteristica.tipo';
      Title := 'Caracter'#237'stica';
    end;
    with tblCaracteristicas.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'Valor';
    end;
    tblCaracteristicas.DataSource := dtsCaracteristicas;
    btnCaracteristicasTab.SetParentComponent(Self);
    btnCaracteristicasTab.Name := 'btnCaracteristicasTab';
    btnCaracteristicasTab.Left := 656;
    btnCaracteristicasTab.Top := 333;
    btnCaracteristicasTab.Width := 96;
    btnCaracteristicasTab.Height := 25;
    btnCaracteristicasTab.Caption := 'Caracter'#237'sticas';
    btnCaracteristicasTab.ChildOrder := 16;
    btnCaracteristicasTab.HeightPercent := 100.000000000000000000;
    btnCaracteristicasTab.WidthPercent := 100.000000000000000000;
    SetEvent(btnCaracteristicasTab, Self, 'OnClick', 'btnCaracteristicasTabClick');
    edtCaracteristica.SetParentComponent(Self);
    edtCaracteristica.Name := 'edtCaracteristica';
    edtCaracteristica.Left := 437;
    edtCaracteristica.Top := 419;
    edtCaracteristica.Width := 120;
    edtCaracteristica.Height := 22;
    edtCaracteristica.ChildOrder := 21;
    edtCaracteristica.Enabled := False;
    edtCaracteristica.HeightPercent := 100.000000000000000000;
    edtCaracteristica.WidthPercent := 100.000000000000000000;
    btnPesquisarCaracteristica.SetParentComponent(Self);
    btnPesquisarCaracteristica.Name := 'btnPesquisarCaracteristica';
    btnPesquisarCaracteristica.Left := 558;
    btnPesquisarCaracteristica.Top := 419;
    btnPesquisarCaracteristica.Width := 30;
    btnPesquisarCaracteristica.Height := 22;
    btnPesquisarCaracteristica.ChildOrder := 22;
    btnPesquisarCaracteristica.HeightPercent := 100.000000000000000000;
    btnPesquisarCaracteristica.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCaracteristica, Self, 'OnClick', 'btnPesquisarCaracteristicaClick');
    btnNovaCaracteristica.SetParentComponent(Self);
    btnNovaCaracteristica.Name := 'btnNovaCaracteristica';
    btnNovaCaracteristica.Left := 304;
    btnNovaCaracteristica.Top := 477;
    btnNovaCaracteristica.Width := 96;
    btnNovaCaracteristica.Height := 25;
    btnNovaCaracteristica.ChildOrder := 16;
    btnNovaCaracteristica.HeightPercent := 100.000000000000000000;
    btnNovaCaracteristica.WidthPercent := 100.000000000000000000;
    SetEvent(btnNovaCaracteristica, Self, 'OnClick', 'btnNovaCaracteristicaClick');
    btnSalvarCaracteristica.SetParentComponent(Self);
    btnSalvarCaracteristica.Name := 'btnSalvarCaracteristica';
    btnSalvarCaracteristica.Left := 304;
    btnSalvarCaracteristica.Top := 508;
    btnSalvarCaracteristica.Width := 96;
    btnSalvarCaracteristica.Height := 25;
    btnSalvarCaracteristica.Caption := 'Salvar';
    btnSalvarCaracteristica.ChildOrder := 70;
    btnSalvarCaracteristica.HeightPercent := 100.000000000000000000;
    btnSalvarCaracteristica.TabOrder := 4;
    btnSalvarCaracteristica.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarCaracteristica, Self, 'OnClick', 'btnSalvarCaracteristicaClick');
    edtValor.SetParentComponent(Self);
    edtValor.Name := 'edtValor';
    edtValor.Left := 436;
    edtValor.Top := 447;
    edtValor.Width := 121;
    edtValor.Height := 22;
    edtValor.ChildOrder := 72;
    edtValor.HeightPercent := 100.000000000000000000;
    edtValor.MaxLength := 255;
    edtValor.WidthPercent := 100.000000000000000000;
    SetEvent(edtValor, Self, 'OnClick', 'edtValorClick');
    btnAlterarImagem.SetParentComponent(Self);
    btnAlterarImagem.Name := 'btnAlterarImagem';
    btnAlterarImagem.Left := 656;
    btnAlterarImagem.Top := 524;
    btnAlterarImagem.Width := 96;
    btnAlterarImagem.Height := 25;
    btnAlterarImagem.Caption := 'Alterar Imagem';
    btnAlterarImagem.ChildOrder := 70;
    btnAlterarImagem.HeightPercent := 100.000000000000000000;
    btnAlterarImagem.TabOrder := 4;
    btnAlterarImagem.WidthPercent := 100.000000000000000000;
    SetEvent(btnAlterarImagem, Self, 'OnClick', 'btnAlterarImagemClick');
    btnPesquisarImagem.SetParentComponent(Self);
    btnPesquisarImagem.Name := 'btnPesquisarImagem';
    btnPesquisarImagem.Left := 656;
    btnPesquisarImagem.Top := 555;
    btnPesquisarImagem.Width := 96;
    btnPesquisarImagem.Height := 25;
    btnPesquisarImagem.Caption := 'Pesquisar';
    btnPesquisarImagem.ChildOrder := 11;
    btnPesquisarImagem.HeightPercent := 100.000000000000000000;
    btnPesquisarImagem.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarImagem, Self, 'OnClick', 'btnPesquisarImagemClick');
    edtNomeProduto.SetParentComponent(Self);
    edtNomeProduto.Name := 'edtNomeProduto';
    edtNomeProduto.Left := 758;
    edtNomeProduto.Top := 479;
    edtNomeProduto.Width := 67;
    edtNomeProduto.Height := 22;
    edtNomeProduto.ChildOrder := 75;
    edtNomeProduto.HeightPercent := 100.000000000000000000;
    edtNomeProduto.WidthPercent := 100.000000000000000000;
    edtCodigoProduto.SetParentComponent(Self);
    edtCodigoProduto.Name := 'edtCodigoProduto';
    edtCodigoProduto.Left := 758;
    edtCodigoProduto.Top := 507;
    edtCodigoProduto.Width := 67;
    edtCodigoProduto.Height := 22;
    edtCodigoProduto.ChildOrder := 75;
    edtCodigoProduto.Enabled := False;
    edtCodigoProduto.HeightPercent := 100.000000000000000000;
    edtCodigoProduto.WidthPercent := 100.000000000000000000;
    btnSalvarImagem.SetParentComponent(Self);
    btnSalvarImagem.Name := 'btnSalvarImagem';
    btnSalvarImagem.Left := 656;
    btnSalvarImagem.Top := 586;
    btnSalvarImagem.Width := 96;
    btnSalvarImagem.Height := 25;
    btnSalvarImagem.Caption := 'Salvar';
    btnSalvarImagem.ChildOrder := 11;
    btnSalvarImagem.HeightPercent := 100.000000000000000000;
    btnSalvarImagem.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarImagem, Self, 'OnClick', 'btnSalvarImagemClick');
    btnRemoverImagemPreview.SetParentComponent(Self);
    btnRemoverImagemPreview.Name := 'btnRemoverImagemPreview';
    btnRemoverImagemPreview.Left := 656;
    btnRemoverImagemPreview.Top := 467;
    btnRemoverImagemPreview.Width := 30;
    btnRemoverImagemPreview.Height := 22;
    btnRemoverImagemPreview.ChildOrder := 22;
    btnRemoverImagemPreview.HeightPercent := 100.000000000000000000;
    btnRemoverImagemPreview.WidthPercent := 100.000000000000000000;
    SetEvent(btnRemoverImagemPreview, Self, 'OnClick', 'WebButton1Click');
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Fs_Prod_ProdutosDataset;
    DataSource.Left := 672;
    DataSource.Top := 80;
    Fs_Prod_ProdutosDataset.SetParentComponent(Self);
    Fs_Prod_ProdutosDataset.Name := 'Fs_Prod_ProdutosDataset';
    Fs_Prod_ProdutosDataset.EntitySetName := 'Fs_Prod_Produtos';
    Fs_Prod_ProdutosDataset.Connection := DMConnection.ApiConnection;
    Fs_Prod_ProdutosDataset.Left := 696;
    Fs_Prod_ProdutosDataset.Top := 16;
    Fs_Prod_ProdutosDatasetid.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetid.Name := 'Fs_Prod_ProdutosDatasetid';
    Fs_Prod_ProdutosDatasetid.FieldName := 'id';
    Fs_Prod_ProdutosDatasetnome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetnome.Name := 'Fs_Prod_ProdutosDatasetnome';
    Fs_Prod_ProdutosDatasetnome.FieldName := 'nome';
    Fs_Prod_ProdutosDatasetnome.Required := True;
    Fs_Prod_ProdutosDatasetnome.Size := 255;
    Fs_Prod_ProdutosDatasetcodigo_barras.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetcodigo_barras.Name := 'Fs_Prod_ProdutosDatasetcodigo_barras';
    Fs_Prod_ProdutosDatasetcodigo_barras.FieldName := 'codigo_barras';
    Fs_Prod_ProdutosDatasetcodigo_barras.Required := True;
    Fs_Prod_ProdutosDatasetcodigo_barras.Size := 255;
    Fs_Prod_ProdutosDatasetcategoria_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetcategoria_id.Name := 'Fs_Prod_ProdutosDatasetcategoria_id';
    Fs_Prod_ProdutosDatasetcategoria_id.FieldName := 'categoria_id';
    Fs_Prod_ProdutosDatasetsubcategoria_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetsubcategoria_id.Name := 'Fs_Prod_ProdutosDatasetsubcategoria_id';
    Fs_Prod_ProdutosDatasetsubcategoria_id.FieldName := 'subcategoria_id';
    Fs_Prod_ProdutosDatasetdepartamento_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetdepartamento_id.Name := 'Fs_Prod_ProdutosDatasetdepartamento_id';
    Fs_Prod_ProdutosDatasetdepartamento_id.FieldName := 'departamento_id';
    Fs_Prod_ProdutosDatasetsubdepartamento_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetsubdepartamento_id.Name := 'Fs_Prod_ProdutosDatasetsubdepartamento_id';
    Fs_Prod_ProdutosDatasetsubdepartamento_id.FieldName := 'subdepartamento_id';
    Fs_Prod_ProdutosDatasetmarca_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetmarca_id.Name := 'Fs_Prod_ProdutosDatasetmarca_id';
    Fs_Prod_ProdutosDatasetmarca_id.FieldName := 'marca_id';
    Fs_Prod_ProdutosDatasetfabricante_id.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetfabricante_id.Name := 'Fs_Prod_ProdutosDatasetfabricante_id';
    Fs_Prod_ProdutosDatasetfabricante_id.FieldName := 'fabricante_id';
    Fs_Prod_ProdutosDatasetcodigos.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetcodigos.Name := 'Fs_Prod_ProdutosDatasetcodigos';
    Fs_Prod_ProdutosDatasetcodigos.FieldName := 'codigos';
    Fs_Prod_ProdutosDatasetcodigos.Size := 255;
    Fs_Prod_ProdutosDatasetpeso.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetpeso.Name := 'Fs_Prod_ProdutosDatasetpeso';
    Fs_Prod_ProdutosDatasetpeso.FieldName := 'peso';
    Fs_Prod_ProdutosDatasetpeso.Size := 255;
    Fs_Prod_ProdutosDatasetembalagem.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetembalagem.Name := 'Fs_Prod_ProdutosDatasetembalagem';
    Fs_Prod_ProdutosDatasetembalagem.FieldName := 'embalagem';
    Fs_Prod_ProdutosDatasetembalagem.Size := 255;
    Fs_Prod_ProdutosDatasetquantidade_embalagem.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetquantidade_embalagem.Name := 'Fs_Prod_ProdutosDatasetquantidade_embalagem';
    Fs_Prod_ProdutosDatasetquantidade_embalagem.FieldName := 'quantidade_embalagem';
    Fs_Prod_ProdutosDatasetquantidade_embalagem.Size := 255;
    Fs_Prod_ProdutosDatasetfoto.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetfoto.Name := 'Fs_Prod_ProdutosDatasetfoto';
    Fs_Prod_ProdutosDatasetfoto.FieldName := 'foto';
    Fs_Prod_ProdutosDatasetfoto.Size := 255;
    Fs_Prod_ProdutosDatasetexcluido.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetexcluido.Name := 'Fs_Prod_ProdutosDatasetexcluido';
    Fs_Prod_ProdutosDatasetexcluido.FieldName := 'excluido';
    Fs_Prod_ProdutosDatasetinclusao.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetinclusao.Name := 'Fs_Prod_ProdutosDatasetinclusao';
    Fs_Prod_ProdutosDatasetinclusao.FieldName := 'inclusao';
    Fs_Prod_ProdutosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_ProdutosDatasetalteracao.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetalteracao.Name := 'Fs_Prod_ProdutosDatasetalteracao';
    Fs_Prod_ProdutosDatasetalteracao.FieldName := 'alteracao';
    Fs_Prod_ProdutosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_ProdutosDatasetexclusao.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetexclusao.Name := 'Fs_Prod_ProdutosDatasetexclusao';
    Fs_Prod_ProdutosDatasetexclusao.FieldName := 'exclusao';
    Fs_Prod_ProdutosDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Fs_Prod_ProdutosDatasetimagem.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetimagem.Name := 'Fs_Prod_ProdutosDatasetimagem';
    Fs_Prod_ProdutosDatasetimagem.FieldName := 'imagem';
    Fs_Prod_ProdutosDatasetimagem.Size := 0;
    Fs_Prod_ProdutosDatasetcategorianome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetcategorianome.Name := 'Fs_Prod_ProdutosDatasetcategorianome';
    Fs_Prod_ProdutosDatasetcategorianome.FieldName := 'categoria.nome';
    Fs_Prod_ProdutosDatasetsubcategorianome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetsubcategorianome.Name := 'Fs_Prod_ProdutosDatasetsubcategorianome';
    Fs_Prod_ProdutosDatasetsubcategorianome.FieldName := 'subcategoria.nome';
    Fs_Prod_ProdutosDatasetdepartamentonome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetdepartamentonome.Name := 'Fs_Prod_ProdutosDatasetdepartamentonome';
    Fs_Prod_ProdutosDatasetdepartamentonome.FieldName := 'departamento.nome';
    Fs_Prod_ProdutosDatasetsubdepartamentonome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetsubdepartamentonome.Name := 'Fs_Prod_ProdutosDatasetsubdepartamentonome';
    Fs_Prod_ProdutosDatasetsubdepartamentonome.FieldName := 'subdepartamento.nome';
    Fs_Prod_ProdutosDatasetmarcanome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetmarcanome.Name := 'Fs_Prod_ProdutosDatasetmarcanome';
    Fs_Prod_ProdutosDatasetmarcanome.FieldName := 'marca.nome';
    Fs_Prod_ProdutosDatasetfabricantenome.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetfabricantenome.Name := 'Fs_Prod_ProdutosDatasetfabricantenome';
    Fs_Prod_ProdutosDatasetfabricantenome.FieldName := 'fabricante.nome';
    Fs_Prod_ProdutosDatasettributacao.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasettributacao.Name := 'Fs_Prod_ProdutosDatasettributacao';
    Fs_Prod_ProdutosDatasettributacao.Tag := 1;
    Fs_Prod_ProdutosDatasettributacao.FieldName := 'tributacao';
    Fs_Prod_ProdutosDatasetadicional.SetParentComponent(Fs_Prod_ProdutosDataset);
    Fs_Prod_ProdutosDatasetadicional.Name := 'Fs_Prod_ProdutosDatasetadicional';
    Fs_Prod_ProdutosDatasetadicional.Tag := 1;
    Fs_Prod_ProdutosDatasetadicional.FieldName := 'adicional';
    XDataClientFs_Prod_ProdutosGet.SetParentComponent(Self);
    XDataClientFs_Prod_ProdutosGet.Name := 'XDataClientFs_Prod_ProdutosGet';
    XDataClientFs_Prod_ProdutosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientFs_Prod_ProdutosGet, Self, 'OnLoad', 'XDataClientFs_Prod_ProdutosGetLoad');
    XDataClientFs_Prod_ProdutosGet.Left := 728;
    XDataClientFs_Prod_ProdutosGet.Top := 144;
    cdsTributacoes.SetParentComponent(Self);
    cdsTributacoes.Name := 'cdsTributacoes';
    cdsTributacoes.EntitySetName := 'Fs_Prod_Tributacoes';
    cdsTributacoes.Connection := DMConnection.ApiConnection;
    cdsTributacoes.Left := 776;
    cdsTributacoes.Top := 16;
    dtsTributacoes.SetParentComponent(Self);
    dtsTributacoes.Name := 'dtsTributacoes';
    dtsTributacoes.DataSet := cdsTributacoes;
    dtsTributacoes.Left := 744;
    dtsTributacoes.Top := 80;
    cdsInformacoesAdicionais.SetParentComponent(Self);
    cdsInformacoesAdicionais.Name := 'cdsInformacoesAdicionais';
    cdsInformacoesAdicionais.EntitySetName := 'Fs_Prod_Informacoes_Adicionais';
    cdsInformacoesAdicionais.Connection := DMConnection.ApiConnection;
    cdsInformacoesAdicionais.Left := 856;
    cdsInformacoesAdicionais.Top := 16;
    cdsInformacoesAdicionaisid.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisid.Name := 'cdsInformacoesAdicionaisid';
    cdsInformacoesAdicionaisid.FieldName := 'id';
    cdsInformacoesAdicionaisid.Required := True;
    cdsInformacoesAdicionaisproduto_id.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisproduto_id.Name := 'cdsInformacoesAdicionaisproduto_id';
    cdsInformacoesAdicionaisproduto_id.FieldName := 'produto_id';
    cdsInformacoesAdicionaisproduto_id.Required := True;
    cdsInformacoesAdicionaisdescricao.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisdescricao.Name := 'cdsInformacoesAdicionaisdescricao';
    cdsInformacoesAdicionaisdescricao.FieldName := 'descricao';
    cdsInformacoesAdicionaisdescricao.Size := 255;
    cdsInformacoesAdicionaisdescricao_sem_tag.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisdescricao_sem_tag.Name := 'cdsInformacoesAdicionaisdescricao_sem_tag';
    cdsInformacoesAdicionaisdescricao_sem_tag.FieldName := 'descricao_sem_tag';
    cdsInformacoesAdicionaisdescricao_sem_tag.Size := 255;
    cdsInformacoesAdicionaisinfo_nutricional_json.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisinfo_nutricional_json.Name := 'cdsInformacoesAdicionaisinfo_nutricional_json';
    cdsInformacoesAdicionaisinfo_nutricional_json.FieldName := 'info_nutricional_json';
    cdsInformacoesAdicionaisinfo_nutricional_json.Size := 255;
    cdsInformacoesAdicionaisficha_tecnica.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisficha_tecnica.Name := 'cdsInformacoesAdicionaisficha_tecnica';
    cdsInformacoesAdicionaisficha_tecnica.FieldName := 'ficha_tecnica';
    cdsInformacoesAdicionaisficha_tecnica.Size := 255;
    cdsInformacoesAdicionaisexcluido.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisexcluido.Name := 'cdsInformacoesAdicionaisexcluido';
    cdsInformacoesAdicionaisexcluido.FieldName := 'excluido';
    cdsInformacoesAdicionaisinclusao.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisinclusao.Name := 'cdsInformacoesAdicionaisinclusao';
    cdsInformacoesAdicionaisinclusao.FieldName := 'inclusao';
    cdsInformacoesAdicionaisalteracao.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisalteracao.Name := 'cdsInformacoesAdicionaisalteracao';
    cdsInformacoesAdicionaisalteracao.FieldName := 'alteracao';
    cdsInformacoesAdicionaisexclusao.SetParentComponent(cdsInformacoesAdicionais);
    cdsInformacoesAdicionaisexclusao.Name := 'cdsInformacoesAdicionaisexclusao';
    cdsInformacoesAdicionaisexclusao.FieldName := 'exclusao';
    dtsInformacoesAdicionais.SetParentComponent(Self);
    dtsInformacoesAdicionais.Name := 'dtsInformacoesAdicionais';
    dtsInformacoesAdicionais.DataSet := cdsInformacoesAdicionais;
    dtsInformacoesAdicionais.Left := 848;
    dtsInformacoesAdicionais.Top := 80;
    XDataWebClientGerenciarProdutos.SetParentComponent(Self);
    XDataWebClientGerenciarProdutos.Name := 'XDataWebClientGerenciarProdutos';
    XDataWebClientGerenciarProdutos.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClientGerenciarProdutos, Self, 'OnLoad', 'XDataWebClientGerenciarProdutosLoad');
    SetEvent(XDataWebClientGerenciarProdutos, Self, 'OnError', 'XDataWebClientGerenciarProdutosError');
    XDataWebClientGerenciarProdutos.Left := 736;
    XDataWebClientGerenciarProdutos.Top := 208;
    cdsCaracteristicas.SetParentComponent(Self);
    cdsCaracteristicas.Name := 'cdsCaracteristicas';
    cdsCaracteristicas.AfterApplyUpdates := cdsCaracteristicasAfterApplyUpdates;
    cdsCaracteristicas.EntitySetName := 'Fs_Prod_Caracteristicas_Produtos';
    cdsCaracteristicas.Connection := DMConnection.ApiConnection;
    cdsCaracteristicas.Left := 329;
    cdsCaracteristicas.Top := 576;
    cdsCaracteristicasid.SetParentComponent(cdsCaracteristicas);
    cdsCaracteristicasid.Name := 'cdsCaracteristicasid';
    cdsCaracteristicasid.FieldName := 'id';
    cdsCaracteristicasvalor.SetParentComponent(cdsCaracteristicas);
    cdsCaracteristicasvalor.Name := 'cdsCaracteristicasvalor';
    cdsCaracteristicasvalor.FieldName := 'valor';
    cdsCaracteristicasvalor.Required := True;
    cdsCaracteristicasvalor.Size := 255;
    cdsCaracteristicasproduto_id.SetParentComponent(cdsCaracteristicas);
    cdsCaracteristicasproduto_id.Name := 'cdsCaracteristicasproduto_id';
    cdsCaracteristicasproduto_id.FieldName := 'produto_id';
    cdsCaracteristicasproduto_id.Required := True;
    cdsCaracteristicascaracteristicatipo.SetParentComponent(cdsCaracteristicas);
    cdsCaracteristicascaracteristicatipo.Name := 'cdsCaracteristicascaracteristicatipo';
    cdsCaracteristicascaracteristicatipo.FieldName := 'caracteristica.tipo';
    cdsCaracteristicascaracteristica_id.SetParentComponent(cdsCaracteristicas);
    cdsCaracteristicascaracteristica_id.Name := 'cdsCaracteristicascaracteristica_id';
    cdsCaracteristicascaracteristica_id.FieldName := 'caracteristica_id';
    cdsCaracteristicascaracteristica_id.Required := True;
    dtsCaracteristicas.SetParentComponent(Self);
    dtsCaracteristicas.Name := 'dtsCaracteristicas';
    dtsCaracteristicas.DataSet := cdsCaracteristicas;
    dtsCaracteristicas.Left := 433;
    dtsCaracteristicas.Top := 592;
    tmrConsultaCaracteristicas.SetParentComponent(Self);
    tmrConsultaCaracteristicas.Name := 'tmrConsultaCaracteristicas';
    tmrConsultaCaracteristicas.Enabled := False;
    SetEvent(tmrConsultaCaracteristicas, Self, 'OnTimer', 'tmrConsultaCaracteristicasTimer');
    tmrConsultaCaracteristicas.Left := 160;
    tmrConsultaCaracteristicas.Top := 472;
    XDataWebSugestaoImagem.SetParentComponent(Self);
    XDataWebSugestaoImagem.Name := 'XDataWebSugestaoImagem';
    XDataWebSugestaoImagem.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebSugestaoImagem, Self, 'OnLoad', 'XDataWebSugestaoImagemLoad');
    SetEvent(XDataWebSugestaoImagem, Self, 'OnError', 'XDataWebSugestaoImagemError');
    XDataWebSugestaoImagem.Left := 592;
    XDataWebSugestaoImagem.Top := 512;
  finally
    lbid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    lbcodigo_barras.AfterLoadDFMValues;
    lbcategoria_id.AfterLoadDFMValues;
    lbsubcategoria_id.AfterLoadDFMValues;
    lbdepartamento_id.AfterLoadDFMValues;
    lbsubdepartamento_id.AfterLoadDFMValues;
    lbmarca_id.AfterLoadDFMValues;
    lbfabricante_id.AfterLoadDFMValues;
    lbcodigos.AfterLoadDFMValues;
    lbpeso.AfterLoadDFMValues;
    lbembalagem.AfterLoadDFMValues;
    lbquantidade_embalagem.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    imgProduto.AfterLoadDFMValues;
    lbncm.AfterLoadDFMValues;
    lbcest.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lbdescricao_sem_tag.AfterLoadDFMValues;
    lbinfo_nutricional_json.AfterLoadDFMValues;
    lbficha_tecnica.AfterLoadDFMValues;
    lbPaginationInfoCaracteristicas.AfterLoadDFMValues;
    lblCaracteristica.AfterLoadDFMValues;
    lblValor.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    edcodigo_barras.AfterLoadDFMValues;
    edcodigos.AfterLoadDFMValues;
    edpeso.AfterLoadDFMValues;
    edembalagem.AfterLoadDFMValues;
    edquantidade_embalagem.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    edtCategoriaNome.AfterLoadDFMValues;
    btnPesquisarCategoria.AfterLoadDFMValues;
    edtSubCategoriaNome.AfterLoadDFMValues;
    btnPesquisarSubCategoria.AfterLoadDFMValues;
    edtDepartamentoNome.AfterLoadDFMValues;
    btnPesquisarDepartamento.AfterLoadDFMValues;
    edtSubDepartamentoNome.AfterLoadDFMValues;
    btnPesquisarSubDepartamento.AfterLoadDFMValues;
    edtMarcaNome.AfterLoadDFMValues;
    btnPesquisarMarca.AfterLoadDFMValues;
    edtFabricanteNome.AfterLoadDFMValues;
    btnPesquisarFabricante.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    btnDadosTab.AfterLoadDFMValues;
    btnAdicionaisTab.AfterLoadDFMValues;
    edncm.AfterLoadDFMValues;
    edcest.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    eddescricao_sem_tag.AfterLoadDFMValues;
    edinfo_nutricional_json.AfterLoadDFMValues;
    edficha_tecnica.AfterLoadDFMValues;
    pnlTabelaCaracteristicas.AfterLoadDFMValues;
    cbPageSizeCaracteristicas.AfterLoadDFMValues;
    edSearchCaracteristicas.AfterLoadDFMValues;
    lcPaginatorCaracteristicas.AfterLoadDFMValues;
    tblCaracteristicas.AfterLoadDFMValues;
    btnCaracteristicasTab.AfterLoadDFMValues;
    edtCaracteristica.AfterLoadDFMValues;
    btnPesquisarCaracteristica.AfterLoadDFMValues;
    btnNovaCaracteristica.AfterLoadDFMValues;
    btnSalvarCaracteristica.AfterLoadDFMValues;
    edtValor.AfterLoadDFMValues;
    btnAlterarImagem.AfterLoadDFMValues;
    btnPesquisarImagem.AfterLoadDFMValues;
    edtNomeProduto.AfterLoadDFMValues;
    edtCodigoProduto.AfterLoadDFMValues;
    btnSalvarImagem.AfterLoadDFMValues;
    btnRemoverImagemPreview.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Fs_Prod_ProdutosDataset.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetid.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetnome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetcodigo_barras.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetcategoria_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetsubcategoria_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetdepartamento_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetsubdepartamento_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetmarca_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetfabricante_id.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetcodigos.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetpeso.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetembalagem.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetquantidade_embalagem.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetfoto.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetexcluido.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetinclusao.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetalteracao.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetexclusao.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetimagem.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetcategorianome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetsubcategorianome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetdepartamentonome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetsubdepartamentonome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetmarcanome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetfabricantenome.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasettributacao.AfterLoadDFMValues;
    Fs_Prod_ProdutosDatasetadicional.AfterLoadDFMValues;
    XDataClientFs_Prod_ProdutosGet.AfterLoadDFMValues;
    cdsTributacoes.AfterLoadDFMValues;
    dtsTributacoes.AfterLoadDFMValues;
    cdsInformacoesAdicionais.AfterLoadDFMValues;
    cdsInformacoesAdicionaisid.AfterLoadDFMValues;
    cdsInformacoesAdicionaisproduto_id.AfterLoadDFMValues;
    cdsInformacoesAdicionaisdescricao.AfterLoadDFMValues;
    cdsInformacoesAdicionaisdescricao_sem_tag.AfterLoadDFMValues;
    cdsInformacoesAdicionaisinfo_nutricional_json.AfterLoadDFMValues;
    cdsInformacoesAdicionaisficha_tecnica.AfterLoadDFMValues;
    cdsInformacoesAdicionaisexcluido.AfterLoadDFMValues;
    cdsInformacoesAdicionaisinclusao.AfterLoadDFMValues;
    cdsInformacoesAdicionaisalteracao.AfterLoadDFMValues;
    cdsInformacoesAdicionaisexclusao.AfterLoadDFMValues;
    dtsInformacoesAdicionais.AfterLoadDFMValues;
    XDataWebClientGerenciarProdutos.AfterLoadDFMValues;
    cdsCaracteristicas.AfterLoadDFMValues;
    cdsCaracteristicasid.AfterLoadDFMValues;
    cdsCaracteristicasvalor.AfterLoadDFMValues;
    cdsCaracteristicasproduto_id.AfterLoadDFMValues;
    cdsCaracteristicascaracteristicatipo.AfterLoadDFMValues;
    cdsCaracteristicascaracteristica_id.AfterLoadDFMValues;
    dtsCaracteristicas.AfterLoadDFMValues;
    tmrConsultaCaracteristicas.AfterLoadDFMValues;
    XDataWebSugestaoImagem.AfterLoadDFMValues;
  end;
end;

end.
